<template>
    <v-container fluid style="overflow: visible !important">
        <v-row>
            <v-col 
                style="display: flex; align-content: center; align-items: center;"
                cols="6"
                lg="6"
                md="6"
                sm="6"
            >
                <h3>Scope of Work - {{ serviceRequest.idFormatted }}</h3>
            </v-col>
            <v-col 
                cols="6"
                style="text-align: right;"
            >
                <v-chip
                    color="var(--color__main)"
                    outlined
                    dark
                >
                    {{ serviceRequest.statusDescription }}
                </v-chip>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <hr />
            </v-col>
        </v-row>

        <v-stepper 
            alt-labels
            v-model="steps"
            style="box-shadow: none; overflow: visible !important"
        >
            <v-layout align-center justify-center>
                <v-row style="display: contents !important;">
                    <v-col>
                        <v-stepper-header
                            style="box-shadow: none; "
                        >
                            <v-stepper-step
                                :complete="steps > 1"
                                step="1"
                            >
                                Check Items
                            </v-stepper-step>

                            <v-divider></v-divider>

                            <v-stepper-step
                                :complete="steps > 2"
                                step="2"
                            >
                                Check Pricing
                            </v-stepper-step>

                            <v-divider></v-divider>

                            <v-stepper-step
                                :complete="steps > 3"
                                step="3"
                            >
                                Proposal
                            </v-stepper-step>

                            <v-divider v-if="isServiceType == false"></v-divider>

                            <v-stepper-step 
                                v-if="isServiceType == false && serviceRequest.techSpecIsRequired == 1"
                                :complete="serviceRequest.status > 7"
                                style="width: 50px;"
                                step="4"
                            >
                                <div style="width: 180px !important; text-align: center;">Technical Specification</div>
                            </v-stepper-step>
                        </v-stepper-header>
                    </v-col>
                </v-row>
            </v-layout>
            
            <v-row>
                <v-col
                    cols="12"
                    lg="12"
                    md="12"
                    sm="12"
                >
                    <JobInformation 
                        :id="serviceRequest.id"
                        :showJobSummary="steps > 1"
                        :project="projectSelected"
                        :refreshJob="refreshJob"
                        :showQuickAccess="isServiceType == true || isSalesType == true"
                        :showQuickAccessAsDocument="isServiceType == true || isSalesType == true"
                        :showProjects="isServiceType == false"
                        :showButtonsCreateEditProject="serviceRequest.status < 6"
                        :showClassification="true"
                        :showDisabledClassification="false"
                        v-on:changeProject="updateProject"
                    />
                </v-col>
            </v-row>

            <v-stepper-items>
                <!-- STEP 1: CHECK ITEMS  -->
                <v-stepper-content step="1">

                    <v-row 
                        v-if="projectSelected != null && projectSelected != undefined"
                    >
                        <v-col
                            cols="12"
                            lg="12"
                            md="12"
                            sm="12"
                            style="padding: 20px;"
                        >
                            <v-card-text>

                                <v-card
                                    class="mx-auto"
                                > 
                                    <v-card-text>
                                        <v-row>
                                            <v-col
                                                style="padding-left: 0px !important; text-align: right;"
                                            >
                                                <label style="font-size: 30px !important; color: var(--color__main);">
                                                    {{ grandAllTotal }}
                                                </label>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </v-card-text>
                        </v-col>
                    </v-row>
                    
                    <v-row 
                        v-if="projectSelected != null && projectSelected != undefined"
                    >
                        <v-col
                            cols="12"
                            lg="12"
                            md="12"
                            sm="12"
                            style="padding-left: 0px !important;"
                        >
                            <v-card-text>

                                <v-card
                                    class="mx-auto"
                                > 
                                    <v-card-title class="text-h5 lighten-2" style="border-bottom: solid 1px var(--color__cinza)">
                                        Items
                                    </v-card-title>

                                    <v-card-text>
                                        <v-row>
                                            <v-col
                                                style="padding-left: 0px !important;"
                                            >
                                                <v-card-text>

                                                    <v-card
                                                        class="mx-auto"
                                                    >
                                                        <v-card-title class="text-h5 lighten-2" style="display: block !important; border-bottom: solid 1px var(--color__cinza)">
                                                            <v-row>
                                                                <v-col 
                                                                    v-if="isProjectPool"
                                                                    cols="12"
                                                                    xl="9"
                                                                    lg="7"
                                                                    md="6"
                                                                    sm="6"
                                                                >
                                                                    <label style="font-size: 14px;">Templates</label>
                                                                    <v-combobox
                                                                        v-model="templateSelected"
                                                                        :items="listTemplate"
                                                                        item-text="name"
                                                                        item-value="id"
                                                                        dense
                                                                        clearable
                                                                        outlined
                                                                    ></v-combobox>
                                                                </v-col>
                                                                <v-col
                                                                    v-if="isProjectPool"
                                                                    cols="12"
                                                                    xl="3"
                                                                    lg="5"
                                                                    md="6"
                                                                    sm="6"
                                                                    style="display: flex; align-content: center; align-items: center;"
                                                                >
                                                                    <v-tooltip left>
                                                                        <template v-slot:activator="{ on }">
                                                                            <v-btn 
                                                                                :style="$vuetify.breakpoint.mobile == true ? 'width: 95% !important; font-size: 12px !important;' : 'font-size: 12px !important;'"
                                                                                class="mx-2"
                                                                                small
                                                                                v-on="on"
                                                                                :disabled="templateSelected == null || templateSelected == undefined"
                                                                                @click="confirmationApplyTemplate()"
                                                                            >
                                                                                Use Template
                                                                            </v-btn>
                                                                        </template>
                                                                        <span>Apply the template selected to the items below</span>
                                                                    </v-tooltip>
                                                                </v-col>
                                                            </v-row>
                                                            <v-row>
                                                                <v-col
                                                                    :style="$vuetify.breakpoint.mobile == true ? 'padding-top: 20px;' : ''"
                                                                    cols="12"
                                                                    lg="12"
                                                                    md="12"
                                                                    sm="12"
                                                                >
                                                                    <v-text-field
                                                                        v-model="searchProduct"
                                                                        label="Search Product"
                                                                        dense
                                                                        prepend-inner-icon="mdi mdi-magnify"
                                                                        single-line
                                                                        outlined
                                                                    ></v-text-field>
                                                                </v-col>
                                                            </v-row>
                                                        </v-card-title>
                                                        <v-card-text>
                                                            <v-treeview
                                                                :items="listTreeViewProduct"
                                                                :search="searchProduct"
                                                                :open.sync="arrayNodeProduct"
                                                                @update:open="onOpenTreeViewProduct"
                                                                :transition="true"
                                                                open-on-click
                                                                rounded
                                                                hoverable
                                                            >
                                                                <template v-slot:prepend="{ item }">
                                                                    <v-icon style="color: var(--color__scopeofwork_category);" v-if="item.type == 'Category'">
                                                                        mdi-shape-outline
                                                                    </v-icon>
                                                                    <v-icon style="color: var(--color__scopeofwork_subcategory);" v-if="item.type == 'SubCategory'">
                                                                        mdi-content-duplicate
                                                                    </v-icon>
                                                                    <v-icon :style="getStyleColor(item)" v-if="item.type == 'Product'">
                                                                        mdi-package-variant-closed
                                                                    </v-icon>
                                                                </template>
                                                                <template v-slot:label="{ item }">                                                                    
                                                                    <v-tooltip 
                                                                        bottom
                                                                    >
                                                                        <template v-slot:activator="{ on }">
                                                                            <v-row
                                                                                v-on="on"
                                                                                :style="userLoggedGetters.profile.systemAdmin == 1 ? 'cursor: pointer;' : ''"
                                                                            >
                                                                                <v-col
                                                                                    cols="9"
                                                                                    style="display: flex; align-items: center; overflow: hidden; min-height: 75px;"
                                                                                    @dblclick="openProductForm(item)"
                                                                                >
                                                                                    <span :style="getStyleColor(item)"> 
                                                                                        {{ item.name }} 
                                                                                        <span style="font-size: 20px; color: red; font-weight: bold;" v-if="isProductMandatory(item) == true || isCategoryOrSubCategoryMandatory(item) == true"> *</span>
                                                                                        <span style="font-size: 10px;" v-if="item.details != '' && item.type == 'Product'"><br />{{ item.details }}</span>

                                                                                        <v-tooltip 
                                                                                            bottom
                                                                                            v-if="item.highlight == 1"
                                                                                        >
                                                                                            <template v-slot:activator="{ on }">
                                                                                                <v-icon 
                                                                                                    v-on="on"
                                                                                                    v-if="item.highlight == 1"
                                                                                                    style="color: var(--color__alert); margin-left: 5px;" 
                                                                                                >
                                                                                                    mdi-alert-octagram-outline
                                                                                                </v-icon>
                                                                                            </template>
                                                                                            <span>{{ item.highlightDescription }}</span>
                                                                                        </v-tooltip>

                                                                                        <v-tooltip 
                                                                                            bottom
                                                                                            v-if="item.customOrder == 1"
                                                                                        >
                                                                                            <template v-slot:activator="{ on }">
                                                                                                <v-icon 
                                                                                                    v-on="on"
                                                                                                    v-if="item.customOrder == 1"
                                                                                                    style="color: var(--color__alert); margin-left: 5px;" 
                                                                                                >
                                                                                                    mdi-package-variant-plus
                                                                                                </v-icon>
                                                                                            </template>
                                                                                            <span>Custom Order</span>
                                                                                        </v-tooltip>

                                                                                        <v-tooltip 
                                                                                            bottom
                                                                                            v-if="item.stylable == 1"
                                                                                        >
                                                                                            <template v-slot:activator="{ on }">
                                                                                                <v-icon 
                                                                                                    v-on="on"
                                                                                                    v-if="item.stylable == 1"
                                                                                                    style="color: var(--color__blue); margin-left: 5px;" 
                                                                                                >
                                                                                                    mdi-palette-swatch-outline
                                                                                                </v-icon>
                                                                                            </template>
                                                                                            <span>Stylable</span>
                                                                                        </v-tooltip>
                                                                                        
                                                                                    </span>
                                                                                </v-col>
                                                                                <v-col
                                                                                    style="display: flex; align-items: center; justify-content: end;"
                                                                                    v-if="item.type == 'Category' || item.type == 'SubCategory'"
                                                                                    cols="3"
                                                                                >
                                                                                  {{ getTotalTree(item) }}
                                                                                </v-col>
                                                                                <v-col
                                                                                    style="display: flex; align-items: center; justify-content: end;"
                                                                                    v-if="item.type == 'Product'"
                                                                                    cols="3"
                                                                                >
                                                                                    <v-text-field
                                                                                        v-if="item.unityFieldType == 1"
                                                                                        :id="'productQty' + item.idTable"
                                                                                        name="qtyField"
                                                                                        style="width: 150px; float: right; max-height: 30px; text-align: center;"
                                                                                        v-model="item.qty"
                                                                                        v-formatMoney="unitProductFormat"
                                                                                        :suffix="item.unitySymbol"
                                                                                        :rules=[validations.mandatoryProduct(item)]
                                                                                        dense
                                                                                        single-line
                                                                                        outlined
                                                                                        @blur="saveItems(true); updateItemsProduct();"
                                                                                    >
                                                                                    </v-text-field>
                                                                                    <v-text-field
                                                                                        v-else
                                                                                        :id="'productQty' + item.idTable"
                                                                                        name="qtyField"
                                                                                        style="width: 150px; float: right; max-height: 30px; text-align: center;"
                                                                                        v-mask="'####'"
                                                                                        v-model="item.qty"
                                                                                        :suffix="item.unitySymbol"
                                                                                        :rules=[validations.mandatoryProduct(item)]
                                                                                        dense
                                                                                        single-line
                                                                                        outlined
                                                                                        @blur="saveItems(true); updateItemsProduct();"
                                                                                    >
                                                                                    </v-text-field>
                                                                                </v-col>
                                                                            </v-row>
                                                                        </template>
                                                                        <span>{{ getDescriptionToolTipProduct(item) }}</span>
                                                                    </v-tooltip>
                                                                </template>
                                                            </v-treeview>
                                                        </v-card-text>
                                                    </v-card>
                                                </v-card-text>
                                            </v-col>

                                            <v-col
                                                cols="12"
                                                md="6"
                                                style="padding-left: 0px !important; height: min-content"
                                                class="sticky-header"
                                            >
                                                <v-card-text
                                                    style="margin-top: 10px;"
                                                >
                                                    <v-card
                                                        class="mx-auto"
                                                    >
                                                        <v-card-title class="text-h5 lighten-2" style="border-bottom: solid 1px var(--color__cinza);">
                                                            <v-col
                                                                cols="9"
                                                            >
                                                                Selected Items
                                                            </v-col>
                                                            <v-col
                                                                style="text-align:right;"
                                                                cols="3"
                                                            >
                                                                <v-tooltip top v-if="!showMoreDetailProductsSW">
                                                                    <template v-slot:activator="{ on }">
                                                                        <v-icon v-on="on" @click="showMoreDetailProductsSW = true"  v-if="!showMoreDetailProductsSW">mdi-eye-off</v-icon>
                                                                    </template>
                                                                    <span>See more details</span>
                                                                </v-tooltip>
                                                                <v-tooltip top v-if="showMoreDetailProductsSW">
                                                                    <template v-slot:activator="{ on }">
                                                                        <v-icon v-on="on" @click="showMoreDetailProductsSW = false" v-if="showMoreDetailProductsSW">mdi-eye</v-icon>
                                                                    </template>
                                                                    <span>Hide more details</span>
                                                                </v-tooltip>
                                                            </v-col>
                                                        </v-card-title>
                                                        <v-card-text style="margin-top: 20px;">
                                                            <v-simple-table
                                                                fixed-header
                                                                style="cursor: pointer;"
                                                            >
                                                                <template v-slot:default>
                                                                    <thead>
                                                                        <tr>
                                                                            <th class="text-left" style="width: 20%">
                                                                                Category / Sub Category
                                                                            </th>
                                                                            <th class="text-left" style="width: 20%">
                                                                                Product
                                                                            </th>
                                                                            <th class="text-center" style="width: 5%">
                                                                                Qty
                                                                            </th>
                                                                            <th class="text-left" style="width: 10%">
                                                                                Option
                                                                            </th>
                                                                            <th class="text-center" style="width: 10%">
                                                                                Not Automatable?
                                                                            </th>
                                                                            <th class="text-right" style="width: 13%" v-if="showMoreDetailProductsSW">
                                                                                Price
                                                                            </th>
                                                                            <th class="text-right" style="width: 13%" v-if="showMoreDetailProductsSW">
                                                                                Total
                                                                            </th>
                                                                            <th class="text-center" style="width: 2%">
                                                                                &nbsp;
                                                                            </th>
                                                                            <th class="text-center" style="width: 2%">
                                                                                &nbsp;
                                                                            </th>
                                                                            <th class="text-center" style="width: 13%">
                                                                                &nbsp;
                                                                            </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr
                                                                            v-for="(item, index) in listProductSelecteds.filter(prd => prd.automation == false || prd.notAutomatable == 1)" :key="index"
                                                                            @click="focusInput(item)"
                                                                        >
                                                                            <td>{{ item.categoryDescription }} {{ item.subCategoryDescription != null && item.subCategoryDescription != undefined && item.subCategoryDescription != '' ? ' / ' + item.subCategoryDescription : '' }}</td>
                                                                            <td>{{ item.productDescription }}</td>
                                                                            <td class="text-center">{{ item.qty }} <span style="font-size: 10px; font-weight: bold;">{{ item.unitySymbol }}</span></td>
                                                                            <td class="text-center">
                                                                                <v-tooltip 
                                                                                    right
                                                                                >
                                                                                    <template v-slot:activator="{ on }">
                                                                                        <v-switch
                                                                                            v-model="item.optional"
                                                                                            color="var(--color__main)"
                                                                                            :value=0
                                                                                            @change="updateOptional(item)"
                                                                                            v-on="on"
                                                                                            @click.stop=""
                                                                                        >
                                                                                        </v-switch>
                                                                                    </template>
                                                                                    <span>Set item as option</span>
                                                                                </v-tooltip>
                                                                            </td>
                                                                            <td class="text-center">
                                                                                <v-tooltip 
                                                                                    right
                                                                                    v-if="item.notAutomatable == 1"
                                                                                >
                                                                                    <template v-slot:activator="{ on }">
                                                                                        <v-switch
                                                                                            v-if="item.notAutomatable == 1"
                                                                                            v-model="item.notAutomatable"
                                                                                            color="var(--color__main)"
                                                                                            :value=0
                                                                                            @change="updateNotAutomatable(item)"
                                                                                            v-on="on"
                                                                                            @click.stop=""
                                                                                        >
                                                                                        </v-switch>
                                                                                    </template>
                                                                                    <span>Set item as not automatable</span>
                                                                                </v-tooltip>
                                                                            </td>
                                                                            <td class="text-right" v-if="showMoreDetailProductsSW">$ {{ item.price }}</td>
                                                                            <td class="text-right" v-if="showMoreDetailProductsSW">$ {{ item.total }}</td>
                                                                            <td class="text-left">
                                                                                <v-tooltip right>
                                                                                    <template v-slot:activator="{ on }">
                                                                                        <v-btn 
                                                                                            class="btnActions"
                                                                                            style="width: 35px; height:35px !important;"
                                                                                            icon 
                                                                                            small 
                                                                                            outlined
                                                                                            v-on="on"
                                                                                            @click.stop=""
                                                                                        >
                                                                                            <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
                                                                                        </v-btn>
                                                                                    </template>
                                                                                    <span>Delete Item</span>
                                                                                </v-tooltip>
                                                                            </td>
                                                                            <td>
                                                                                <v-tooltip right>
                                                                                    <template v-slot:activator="{ on }">
                                                                                        <v-btn 
                                                                                            class="btnActions"
                                                                                            :style="((item.note != null && item.note != undefined && item.note != '') || (item.styling != null && item.styling != undefined && item.styling != '')) ? 'width: 35px; height:35px !important;' : 'color: gray !important; width: 35px; height:35px !important;'"
                                                                                            icon 
                                                                                            small 
                                                                                            outlined
                                                                                            v-on="on"
                                                                                            @click.stop=""
                                                                                        >
                                                                                            <v-icon small @click="showItemNote(item, 'PRODUCT')">mdi-message-bulleted</v-icon>
                                                                                        </v-btn>
                                                                                    </template>
                                                                                    <span> {{ item.stylable == 1 ? 'Add/Remove notes and styling' : 'Add/Remove Notes' }}</span>
                                                                                </v-tooltip>
                                                                            </td>
                                                                            <td>
                                                                                <v-tooltip right>
                                                                                    <template v-slot:activator="{ on }">
                                                                                        <v-btn 
                                                                                            class="btnActions"
                                                                                            style="width: 35px; height:35px !important;"
                                                                                            icon 
                                                                                            small 
                                                                                            outlined
                                                                                            v-on="on"
                                                                                            @click.stop=""
                                                                                        >
                                                                                            <v-icon small @click="showProductsImages(item)">mdi-folder-multiple-image</v-icon>
                                                                                        </v-btn>
                                                                                    </template>
                                                                                    <span>View Image</span>
                                                                                </v-tooltip>

                                                                                <v-tooltip right>
                                                                                    <template v-slot:activator="{ on }">
                                                                                        <v-btn 
                                                                                            class="btnActions"
                                                                                            style="width: 35px; height:35px !important;"
                                                                                            icon 
                                                                                            small 
                                                                                            outlined
                                                                                            v-on="on"
                                                                                            @click.stop=""
                                                                                        >
                                                                                            <v-icon small @click="showProductsDocs(item)">mdi-dock-window</v-icon>
                                                                                        </v-btn>
                                                                                    </template>
                                                                                    <span>View Docs</span>
                                                                                </v-tooltip>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                    <tfoot 
                                                                        v-if="showMoreDetailProductsSW"
                                                                        style="height: 50px; background-color: #eee;"
                                                                    >
                                                                        <tr>
                                                                            <th class="text-left"></th>
                                                                            <th class="text-left"></th>
                                                                            <th class="text-left"></th>
                                                                            <th class="text-left"></th>
                                                                            <th class="text-left"></th>
                                                                            <th class="text-right" style="padding-top: 10px !important; color: var(--color__main); font-size: 20px;">
                                                                                Total
                                                                            </th>
                                                                            <th colspan="4" 
                                                                                valign="middle"
                                                                                class="text-left" 
                                                                                style="padding-top: 10px !important; color: var(--color__main); font-size: 20px;"
                                                                            >
                                                                                {{ grandTotalSelectedProducts }}
                                                                            </th>
                                                                        </tr>                                                                        
                                                                    </tfoot>
                                                                </template>
                                                            </v-simple-table>
                                                        </v-card-text>

                                                    </v-card>
                                                    
                                                </v-card-text>

                                                <v-card-text
                                                    style="margin-top: 10px;"
                                                >
                                                    <v-card
                                                        class="mx-auto"
                                                    >
                                                        <v-card-title class="text-h5 lighten-2" style="border-bottom: solid 1px var(--color__cinza)">
                                                            Automation
                                                        </v-card-title>
                                                        <v-card-text style="margin-top: 20px;">
                                                            <label>Automation Controller</label>
                                                            <v-simple-table
                                                                fixed-header
                                                                style="cursor: pointer;"
                                                            >
                                                                <template v-slot:default>
                                                                    <thead>
                                                                        <tr>
                                                                            <th class="text-left">
                                                                                Sub Category
                                                                            </th>
                                                                            <th class="text-left" >
                                                                                Product
                                                                            </th>
                                                                            <th class="text-center">
                                                                                Qty
                                                                            </th>
                                                                            <th class="text-center">
                                                                                Channel Qty
                                                                            </th>
                                                                            <th class="text-center" style="width: 10%">
                                                                                Option
                                                                            </th>
                                                                            <th class="text-right" style="width: 13%" v-if="showMoreDetailProductsSW">
                                                                                Price
                                                                            </th>
                                                                            <th class="text-right" style="width: 13%" v-if="showMoreDetailProductsSW">
                                                                                Total
                                                                            </th>
                                                                            <th class="text-center">
                                                                                &nbsp;
                                                                            </th>
                                                                            <th class="text-center">
                                                                                &nbsp;
                                                                            </th>
                                                                            <th class="text-center">
                                                                                &nbsp;
                                                                            </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr
                                                                            v-for="(item, index) in listProductSelecteds.filter(prd => prd.automationCenter == 1)" :key="index"
                                                                            @click="focusInput(item)"
                                                                        >
                                                                            <td>{{ item.subCategoryDescription }}</td>
                                                                            <td>{{ item.productDescription }}</td>
                                                                            <td class="text-center">{{ item.qty }} <span style="font-size: 10px; font-weight: bold;">{{ item.unitySymbol }}</span></td>
                                                                            <td class="text-center">{{ item.channelQty }}</td>
                                                                            <td class="text-center">
                                                                                <v-tooltip 
                                                                                    right
                                                                                >
                                                                                    <template v-slot:activator="{ on }">
                                                                                        <v-switch
                                                                                            v-model="item.optional"
                                                                                            color="var(--color__main)"
                                                                                            :value=0
                                                                                            @change="updateOptional(item)"
                                                                                            v-on="on"
                                                                                            @click.stop=""
                                                                                        >
                                                                                        </v-switch>
                                                                                    </template>
                                                                                    <span>Set item as option</span>
                                                                                </v-tooltip>
                                                                            </td>
                                                                            <td class="text-right" v-if="showMoreDetailProductsSW">$ {{ item.price }}</td>
                                                                            <td class="text-right" v-if="showMoreDetailProductsSW">$ {{ item.total }}</td>
                                                                            <td>
                                                                                <v-tooltip right>
                                                                                    <template v-slot:activator="{ on }">
                                                                                        <v-btn 
                                                                                            class="btnActions"
                                                                                            style="width: 35px; height:35px !important;"
                                                                                            icon 
                                                                                            small 
                                                                                            outlined
                                                                                            v-on="on"
                                                                                            @click.stop=""
                                                                                        >
                                                                                            <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
                                                                                        </v-btn>
                                                                                    </template>
                                                                                    <span>Delete Item</span>
                                                                                </v-tooltip>
                                                                            </td>
                                                                            <td>
                                                                                <v-tooltip right>
                                                                                    <template v-slot:activator="{ on }">
                                                                                        <v-btn 
                                                                                            class="btnActions"
                                                                                            :style="item.note != null && item.note != undefined && item.note != '' ? 'width: 35px; height:35px !important;' : 'color: gray !important; width: 35px; height:35px !important;'"
                                                                                            icon 
                                                                                            small 
                                                                                            outlined
                                                                                            v-on="on"
                                                                                            @click.stop=""
                                                                                        >
                                                                                            <v-icon small @click="showItemNote(item, 'PRODUCT')">mdi-message-bulleted</v-icon>
                                                                                        </v-btn>
                                                                                    </template>
                                                                                    <span>Add/Remove Notes</span>
                                                                                </v-tooltip>
                                                                            </td>
                                                                            <td>
                                                                                <v-tooltip right>
                                                                                    <template v-slot:activator="{ on }">
                                                                                        <v-btn 
                                                                                            class="btnActions"
                                                                                            style="width: 35px; height:35px !important;"
                                                                                            icon 
                                                                                            small 
                                                                                            outlined
                                                                                            v-on="on"
                                                                                            @click.stop=""
                                                                                        >
                                                                                            <v-icon small @click="showProductsImages(item)">mdi-folder-multiple-image</v-icon>
                                                                                        </v-btn>
                                                                                    </template>
                                                                                    <span>View Image</span>
                                                                                </v-tooltip>

                                                                                <v-tooltip right>
                                                                                    <template v-slot:activator="{ on }">
                                                                                        <v-btn 
                                                                                            class="btnActions"
                                                                                            style="width: 35px; height:35px !important;"
                                                                                            icon 
                                                                                            small 
                                                                                            outlined
                                                                                            v-on="on"
                                                                                            @click.stop=""
                                                                                        >
                                                                                            <v-icon small @click="showProductsDocs(item)">mdi-dock-window</v-icon>
                                                                                        </v-btn>
                                                                                    </template>
                                                                                    <span>View Docs</span>
                                                                                </v-tooltip>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                    <tfoot 
                                                                        v-if="showMoreDetailProductsSW"
                                                                        style="height: 50px; background-color: #eee;"
                                                                    >
                                                                        <tr>
                                                                            <th class="text-left"></th>
                                                                            <th class="text-left"></th>
                                                                            <th class="text-left"></th>
                                                                            <th class="text-left"></th>
                                                                            <th class="text-left"></th>
                                                                            <th class="text-right" style="padding-top: 10px !important; color: var(--color__main); font-size: 20px;">
                                                                                Total
                                                                            </th>
                                                                            <th colspan="4" 
                                                                                valign="middle"
                                                                                class="text-left" 
                                                                                style="padding-top: 10px !important; color: var(--color__main); font-size: 20px;"
                                                                            >
                                                                                {{ grandTotalAutomationControllers }}
                                                                            </th>
                                                                        </tr>                                                                        
                                                                    </tfoot>
                                                                </template>
                                                            </v-simple-table>
                                                        </v-card-text>

                                                        <v-card-text style="margin-top: 20px;">
                                                            <label>Automated Items</label><label :style="automationItemsIsValid == false ? 'color: var(--color__red);' : ''">- [{{ qtyChannels }} channels available]</label>
                                                            <v-simple-table
                                                                fixed-header
                                                                style="cursor: pointer;"
                                                            >
                                                                <template v-slot:default>
                                                                    <thead>
                                                                        <tr>
                                                                            <th class="text-left">
                                                                                Sub Category
                                                                            </th>
                                                                            <th class="text-left" >
                                                                                Product
                                                                            </th>
                                                                            <th class="text-center">
                                                                                Qty
                                                                            </th>
                                                                            <th class="text-center">
                                                                                Option
                                                                            </th>
                                                                            <th class="text-center">
                                                                                Not Automatable?
                                                                            </th>
                                                                            <th class="text-right" style="width: 13%" v-if="showMoreDetailProductsSW">
                                                                                Price
                                                                            </th>
                                                                            <th class="text-right" style="width: 13%" v-if="showMoreDetailProductsSW">
                                                                                Total
                                                                            </th>
                                                                            <th class="text-center">
                                                                                &nbsp;
                                                                            </th>
                                                                            <th class="text-center">
                                                                                &nbsp;
                                                                            </th>
                                                                            <th class="text-center">
                                                                                &nbsp;
                                                                            </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr
                                                                            v-for="(item, index) in listProductSelecteds.filter(prd => prd.automatable == 1 && prd.notAutomatable == 0)" :key="index"
                                                                            @click="focusInput(item)"
                                                                        >
                                                                            <td>{{ item.subCategoryDescription }}</td>
                                                                            <td>{{ item.productDescription }}</td>
                                                                            <td class="text-center">{{ item.qty }} <span style="font-size: 10px; font-weight: bold;">{{ item.unitySymbol }}</span></td>
                                                                            <td class="text-center">
                                                                                <v-tooltip 
                                                                                    right
                                                                                >
                                                                                    <template v-slot:activator="{ on }">
                                                                                        <v-switch
                                                                                            v-model="item.optional"
                                                                                            color="var(--color__main)"
                                                                                            :value=0
                                                                                            @change="updateOptional(item)"
                                                                                            v-on="on"
                                                                                            @click.stop=""
                                                                                        >
                                                                                        </v-switch>
                                                                                    </template>
                                                                                    <span>Set item as option</span>
                                                                                </v-tooltip>
                                                                            </td>
                                                                            <td class="text-center">
                                                                                <v-tooltip right>
                                                                                    <template v-slot:activator="{ on }">
                                                                                        <v-switch
                                                                                            v-on="on"
                                                                                            v-model="item.notAutomatable"
                                                                                            color="var(--color__main)"
                                                                                            :value=0
                                                                                            @change="updateNotAutomatable(item)"
                                                                                            @click.stop=""
                                                                                        >
                                                                                        </v-switch>
                                                                                    </template>
                                                                                    <span>Set item as not automatable</span>
                                                                                </v-tooltip>
                                                                            </td>
                                                                            <td class="text-right" v-if="showMoreDetailProductsSW">$ {{ item.price }}</td>
                                                                            <td class="text-right" v-if="showMoreDetailProductsSW">$ {{ item.total }}</td>
                                                                            <td>
                                                                                <v-tooltip right>
                                                                                    <template v-slot:activator="{ on }">
                                                                                        <v-btn 
                                                                                            class="btnActions"
                                                                                            style="width: 35px; height:35px !important;"
                                                                                            icon 
                                                                                            small 
                                                                                            outlined
                                                                                            v-on="on"
                                                                                            @click.stop=""
                                                                                        >
                                                                                            <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
                                                                                        </v-btn>
                                                                                    </template>
                                                                                    <span>Delete Item</span>
                                                                                </v-tooltip>
                                                                            </td>
                                                                            <td>
                                                                                <v-tooltip right>
                                                                                    <template v-slot:activator="{ on }">
                                                                                        <v-btn 
                                                                                            class="btnActions"
                                                                                            :style="item.note != null && item.note != undefined && item.note != '' ? 'width: 35px; height:35px !important;' : 'color: gray !important; width: 35px; height:35px !important;'"
                                                                                            icon 
                                                                                            small 
                                                                                            outlined
                                                                                            v-on="on"
                                                                                            @click.stop=""
                                                                                        >
                                                                                            <v-icon small @click="showItemNote(item, 'PRODUCT')">mdi-message-bulleted</v-icon>
                                                                                        </v-btn>
                                                                                    </template>
                                                                                    <span>Add/Remove Notes</span>
                                                                                </v-tooltip>
                                                                            </td>
                                                                            <td>
                                                                                <v-tooltip right>
                                                                                    <template v-slot:activator="{ on }">
                                                                                        <v-btn 
                                                                                            class="btnActions"
                                                                                            style="width: 35px; height:35px !important;"
                                                                                            icon 
                                                                                            small 
                                                                                            outlined
                                                                                            v-on="on"
                                                                                            @click.stop=""
                                                                                        >
                                                                                            <v-icon small @click="showProductsImages(item)">mdi-folder-multiple-image</v-icon>
                                                                                        </v-btn>
                                                                                    </template>
                                                                                    <span>View Image</span>
                                                                                </v-tooltip>

                                                                                <v-tooltip right>
                                                                                    <template v-slot:activator="{ on }">
                                                                                        <v-btn 
                                                                                            class="btnActions"
                                                                                            style="width: 35px; height:35px !important;"
                                                                                            icon 
                                                                                            small 
                                                                                            outlined
                                                                                            v-on="on"
                                                                                            @click.stop=""
                                                                                        >
                                                                                            <v-icon small @click="showProductsDocs(item)">mdi-dock-window</v-icon>
                                                                                        </v-btn>
                                                                                    </template>
                                                                                    <span>View Docs</span>
                                                                                </v-tooltip>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                    <tfoot 
                                                                        v-if="showMoreDetailProductsSW"
                                                                        style="height: 50px; background-color: #eee;"
                                                                    >
                                                                        <tr>
                                                                            <th class="text-left"></th>
                                                                            <th class="text-left"></th>
                                                                            <th class="text-left"></th>
                                                                            <th class="text-left"></th>
                                                                            <th class="text-left"></th>
                                                                            <th class="text-right" style="padding-top: 10px !important; color: var(--color__main); font-size: 20px;">
                                                                                Total
                                                                            </th>
                                                                            <th colspan="4" 
                                                                                valign="middle"
                                                                                class="text-left" 
                                                                                style="padding-top: 10px !important; color: var(--color__main); font-size: 20px;"
                                                                            >
                                                                                {{ grandTotalAutomationItems }}
                                                                            </th>
                                                                        </tr>                                                                        
                                                                    </tfoot>
                                                                </template>
                                                            </v-simple-table>
                                                        </v-card-text>

                                                    </v-card>
                                                    
                                                </v-card-text>

                                                <v-card-text>

                                                    <v-card
                                                        class="mx-auto"
                                                        style="height: 220px !important;"
                                                    >
                                                        <v-card-title class="text-h5 lighten-2" style="border-bottom: solid 1px var(--color__cinza)">
                                                            Notes
                                                        </v-card-title>
                                                        <v-card-text style="margin-top: 20px;">
                                                            <v-textarea
                                                                v-model="projectSelected.notesScopeOfWork"
                                                                rows="5"
                                                                row-height="35"
                                                                placeholder="Add notes here"
                                                                outlined
                                                            >
                                                            </v-textarea>
                                                        </v-card-text>

                                                    </v-card>
                                                    
                                                </v-card-text>

                                                <v-dialog
                                                    v-model="showDialogItemNote"
                                                    transition="dialog-top-transition"
                                                    persistent
                                                    width="800"
                                                    :fullscreen="$vuetify.breakpoint.mobile"
                                                >
                                                
                                                    <v-card>
                                                        <v-card-title class="text-h5 lighten-2 formDialog" style="border-bottom: solid 1px var(--color__cinza)">
                                                            {{ itemDescription }}
                                                        </v-card-title>

                                                        <v-card-text style="margin-top: 20px;">
                                                            <v-row>
                                                                <v-col 
                                                                    cols="12"
                                                                    lg="12"
                                                                    md="12"
                                                                    sm="12"
                                                                >
                                                                    <label>Notes</label>
                                                                    
                                                                    <v-textarea
                                                                        v-model="itemNote"
                                                                        single-line
                                                                        rows="3"
                                                                        row-height="30"
                                                                        outlined
                                                                    >
                                                                    </v-textarea>
                                                                </v-col>
                                                            </v-row>

                                                            <v-row>
                                                                <v-col 
                                                                    cols="12"
                                                                    lg="12"
                                                                    md="12"
                                                                    sm="12"
                                                                >
                                                                    <v-checkbox
                                                                        v-model="itemPrintNote"
                                                                        label="Print note on proposal"
                                                                        hide-details
                                                                    ></v-checkbox>
                                                                </v-col>
                                                            </v-row>

                                                            <v-row
                                                                v-if="isStylable == true"
                                                            >
                                                                <v-col 
                                                                    cols="12"
                                                                    lg="12"
                                                                    md="12"
                                                                    sm="12"
                                                                >
                                                                    <label>Styling</label>
                                                                    
                                                                    <v-textarea
                                                                        v-model="itemStyling"
                                                                        single-line
                                                                        rows="3"
                                                                        row-height="30"
                                                                        outlined
                                                                    >
                                                                    </v-textarea>
                                                                </v-col>
                                                            </v-row>
                                                        </v-card-text>

                                                        <v-divider></v-divider>

                                                        <v-card-actions>
                                                            <div style="width: 100%; text-align: center;">
                                                                <v-btn
                                                                    class="mx-2 buttonCancelDialog"
                                                                    style=""
                                                                    outlined
                                                                    @click="showDialogItemNote = false"
                                                                >
                                                                    Cancel
                                                                </v-btn>

                                                                <v-btn
                                                                    class="mx-2"
                                                                    outlined
                                                                    @click="saveItemNote()"
                                                                >
                                                                    Save
                                                                </v-btn>
                                                            </div>
                                                        </v-card-actions>
                                                    </v-card>
                                                </v-dialog>

                                                <v-card-text>

                                                    <v-card
                                                        class="mx-auto"
                                                    >
                                                        <v-card-title class="text-h5 lighten-2" style="border-bottom: solid 1px var(--color__cinza)">
                                                            <v-row>
                                                                <v-col 
                                                                    cols="6"
                                                                    lg="6"
                                                                    md="6"
                                                                    sm="6"
                                                                >
                                                                    Custom Items
                                                                </v-col>
                                                                <v-col 
                                                                    cols="6"
                                                                    style="text-align: right;"
                                                                >
                                                                    <v-tooltip top>
                                                                        <template v-slot:activator="{ on }">
                                                                            <v-btn 
                                                                                style="width: 45px;"
                                                                                class="btnActions"
                                                                                outlined
                                                                                fab
                                                                                x-small
                                                                                v-on="on"
                                                                                @click="showDialogCustomItemAndClearFields()" 
                                                                                small
                                                                            >
                                                                                <v-icon>mdi-plus</v-icon>
                                                                            </v-btn>
                                                                        </template>
                                                                        <span>Add New Custom Item</span>
                                                                    </v-tooltip>
                                                                </v-col>
                                                            </v-row>
                                                        </v-card-title>
                                                        <v-card-text style="margin-top: 20px;">
                                                            <v-simple-table
                                                                fixed-header
                                                                style="cursor: pointer;"
                                                            >
                                                                <template v-slot:default>
                                                                    <thead>
                                                                        <tr>
                                                                            <th class="text-left" :style="`${showMoreDetailProductsSW ? 'width: 40%' : 'width: 70%'};`">
                                                                                Description
                                                                            </th>
                                                                            <th class="text-center">
                                                                                Qty
                                                                            </th>
                                                                            <th class="text-left" style="width: 10%">
                                                                                Option
                                                                            </th>
                                                                            <th v-if="showMoreDetailProductsSW">
                                                                                Price
                                                                            </th>
                                                                            <th v-if="showMoreDetailProductsSW">
                                                                                Total
                                                                            </th>
                                                                            <th class="text-center">
                                                                                &nbsp;
                                                                            </th>
                                                                            <th class="text-center">
                                                                                &nbsp;
                                                                            </th>
                                                                            <th class="text-center">
                                                                                &nbsp;
                                                                            </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr
                                                                            v-for="(item, index) in listCustomItems" :key="index"
                                                                        >
                                                                            <td>{{ item.description }}</td>
                                                                            <td class="text-center">{{ item.qty }}</td>
                                                                            <td>
                                                                                <v-tooltip 
                                                                                    right
                                                                                >
                                                                                    <template v-slot:activator="{ on }">
                                                                                        <v-switch
                                                                                            v-model="item.optional"
                                                                                            color="var(--color__main)"
                                                                                            :value=0
                                                                                            @change="updateOptionalCustomItem(item)"
                                                                                            v-on="on"
                                                                                        >
                                                                                        </v-switch>
                                                                                    </template>
                                                                                    <span>Set item as option</span>
                                                                                </v-tooltip>
                                                                            </td>
                                                                            <td v-if="showMoreDetailProductsSW">{{ item.priceFormatted }}</td>
                                                                            <td v-if="showMoreDetailProductsSW">{{ item.totalFormatted }}</td>
                                                                            <td>
                                                                                <v-tooltip right>
                                                                                    <template v-slot:activator="{ on }">
                                                                                        <v-btn
                                                                                            class="btnActions"
                                                                                            style="width: 35px; height:35px !important;"
                                                                                            icon 
                                                                                            small 
                                                                                            outlined
                                                                                            v-on="on"
                                                                                        >
                                                                                            <v-icon small @click="showDialogCustomItemAndFillFields(item.id)">mdi-pencil</v-icon>
                                                                                        </v-btn>
                                                                                    </template>
                                                                                    <span>Edit Item</span>
                                                                                </v-tooltip>
                                                                            </td>
                                                                            <td>
                                                                                <v-tooltip right>
                                                                                    <template v-slot:activator="{ on }">
                                                                                        <v-btn
                                                                                            class="btnActions"
                                                                                            style="width: 35px; height:35px !important;"
                                                                                            icon 
                                                                                            small 
                                                                                            outlined
                                                                                            v-on="on"
                                                                                        >
                                                                                            <v-icon small @click="deleteItemCustom(item.id)">mdi-delete</v-icon>
                                                                                        </v-btn>
                                                                                    </template>
                                                                                    <span>Delete Item</span>
                                                                                </v-tooltip>
                                                                            </td>
                                                                            <td>
                                                                                <v-tooltip right>
                                                                                    <template v-slot:activator="{ on }">
                                                                                        <v-btn
                                                                                            class="btnActions"
                                                                                            style="width: 35px; height:35px !important;"
                                                                                            icon 
                                                                                            small 
                                                                                            outlined
                                                                                            v-on="on"
                                                                                        >
                                                                                            <v-icon small @click="showDialogCustomItemUploadImages(item.id)">mdi-folder-multiple-image</v-icon>
                                                                                        </v-btn>
                                                                                    </template>
                                                                                    <span>Upload Images</span>
                                                                                </v-tooltip>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                    <tfoot 
                                                                        v-if="showMoreDetailProductsSW"
                                                                        style="height: 50px; background-color: #eee;"
                                                                    >
                                                                        <tr>
                                                                            <th class="text-left"></th>
                                                                            <th class="text-left"></th>
                                                                            <th class="text-left"></th>
                                                                            <th class="text-right" style="padding-top: 10px !important; color: var(--color__main); font-size: 20px;">
                                                                                Total
                                                                            </th>
                                                                            <th colspan="4" 
                                                                                valign="middle"
                                                                                class="text-left" 
                                                                                style="padding-top: 10px !important; color: var(--color__main); font-size: 20px;"
                                                                            >
                                                                                {{ grandTotalProductsCustomItems.formatted }}
                                                                            </th>
                                                                        </tr>
                                                                    </tfoot>
                                                                </template>
                                                            </v-simple-table>
                                                        </v-card-text>
                                                        
                                                        <!-- DIALOG CUSTOM ITEMS -->
                                                        <v-dialog
                                                            v-model="showDialogCustomItem"
                                                            transition="dialog-top-transition"
                                                            persistent
                                                            width="1000"
                                                            :fullscreen="$vuetify.breakpoint.mobile"
                                                        >
                                                            <v-card>
                                                                <v-card-title class="text-h5 lighten-2 formDialog" style="border-bottom: solid 1px var(--color__cinza)">
                                                                    Add New Custom Item
                                                                </v-card-title>

                                                                <v-card-text style="margin-top: 20px;">
                                                                    <v-form
                                                                        ref="formCustomItem"
                                                                        v-model="validFormCustomItem"
                                                                        lazy-validation
                                                                    >
                                                                        <v-row>
                                                                            <v-col 
                                                                                cols="12"
                                                                                lg="4"
                                                                                md="4"
                                                                                sm="12"
                                                                            >
                                                                                <label>Description</label>
                                                                                <v-text-field
                                                                                    v-model="serviceItemCustomRequest.description" 
                                                                                    :rules=[validations.required]
                                                                                    single-line
                                                                                    outlined
                                                                                    dense
                                                                                >
                                                                                </v-text-field>
                                                                            </v-col>
                                                                            <v-col 
                                                                                cols="12"
                                                                                lg="2"
                                                                                md="4"
                                                                                sm="12"
                                                                            >
                                                                                <label>Optional</label>
                                                                                <v-switch
                                                                                    style="margin-top: 3px;"
                                                                                    v-model="serviceItemCustomRequest.optional"
                                                                                    color="var(--color__main)"
                                                                                    :value=0
                                                                                >
                                                                                </v-switch>
                                                                            </v-col>
                                                                            <v-col 
                                                                                style="text-align: center;"
                                                                                cols="12"
                                                                                lg="2"
                                                                                md="4"
                                                                                sm="12"
                                                                            >
                                                                                <label>Qty</label>
                                                                                <v-text-field
                                                                                    name="qtyField"
                                                                                    style="width: 150px; float: right; max-height: 30px; text-align: center;"
                                                                                    v-model="serviceItemCustomRequest.qty"
                                                                                    v-formatMoney="moneyFormat"
                                                                                    v-mask="'####'"
                                                                                    suffix="UN"
                                                                                    single-line
                                                                                    outlined
                                                                                    @blur="calculateItemCustomTotal()"
                                                                                    dense
                                                                                >
                                                                                </v-text-field>
                                                                                
                                                                            </v-col>
                                                                            <v-col 
                                                                                style="text-align: right;"
                                                                                cols="12"
                                                                                lg="2"
                                                                                md="4"
                                                                                sm="12"
                                                                            >
                                                                                <label>Price</label>
                                                                                <v-text-field
                                                                                    name="moneyField"
                                                                                    style="width: 150px; float: right; max-height: 30px; text-align: center;"
                                                                                    v-model="serviceItemCustomRequest.price"
                                                                                    v-formatMoney="moneyFormat"
                                                                                    single-line
                                                                                    outlined
                                                                                    @blur="calculateItemCustomTotal()"
                                                                                    dense
                                                                                >
                                                                                </v-text-field>
                                                                                
                                                                            </v-col>
                                                                            <v-col 
                                                                                style="text-align: right;"
                                                                                cols="12"
                                                                                lg="2"
                                                                                md="4"
                                                                                sm="12"
                                                                            >
                                                                                <label>Total</label>
                                                                                <v-text-field
                                                                                    name="moneyField"
                                                                                    style="width: 150px; float: right; max-height: 30px; text-align: center;"
                                                                                    prefix="$"
                                                                                    v-model="serviceItemCustomRequest.total"
                                                                                    v-formatMoney="moneyFormat"
                                                                                    disabled
                                                                                    single-line
                                                                                    outlined
                                                                                    dense
                                                                                >
                                                                                </v-text-field>                                                                                
                                                                            </v-col>
                                                                        </v-row>
                                                                        <v-row>
                                                                            <v-col 
                                                                                cols="12"
                                                                                lg="12"
                                                                                md="12"
                                                                                sm="12"
                                                                            >
                                                                                <label>Notes</label>
                                                                                <v-textarea
                                                                                    v-model="serviceItemCustomRequest.note"
                                                                                    single-line
                                                                                    rows="3"
                                                                                    row-height="30"
                                                                                    outlined
                                                                                    dense
                                                                                >
                                                                                </v-textarea>
                                                                            </v-col>
                                                                        </v-row>
                                                                        <v-row>
                                                                            <v-col 
                                                                                cols="12"
                                                                                lg="6"
                                                                                md="6"
                                                                                sm="12"
                                                                            >
                                                                                <label>Warranty Days</label>
                                                                                <v-text-field
                                                                                    v-model="serviceItemCustomRequest.warrantyDays"
                                                                                    :rules=[validations.required]
                                                                                    type="number"
                                                                                    min="0"
                                                                                    single-line
                                                                                    outlined
                                                                                    dense
                                                                                >
                                                                                </v-text-field>
                                                                            </v-col>
                                                                            <v-col 
                                                                                cols="12"
                                                                                lg="6"
                                                                                md="6"
                                                                                sm="12"
                                                                            >
                                                                                <label>Serial Number <span style="font-size: 10px; color: gray;">(optional)</span></label>
                                                                                <v-text-field
                                                                                    v-model="serviceItemCustomRequest.serialNumber"
                                                                                    single-line
                                                                                    outlined
                                                                                    dense
                                                                                >
                                                                                </v-text-field>
                                                                            </v-col>
                                                                        </v-row>
                                                                    </v-form>
                                                                </v-card-text>

                                                                <v-divider></v-divider>

                                                                <v-card-actions>
                                                                    <div style="width: 100%; text-align: center;">
                                                                        <v-btn
                                                                            class="mx-2 buttonCancelDialog"
                                                                            style=""
                                                                            outlined
                                                                            @click="showDialogCustomItem = false"
                                                                        >
                                                                            Cancel
                                                                        </v-btn>

                                                                        <v-btn
                                                                            class="mx-2"
                                                                            outlined
                                                                            @click="saveItemCustom()"
                                                                        >
                                                                            Save
                                                                        </v-btn>
                                                                    </div>
                                                                </v-card-actions>
                                                            </v-card>
                                                        </v-dialog>
                                                        
                                                        <!-- DIALOG CUSTOM ITEMS IMAGES -->
                                                        <v-dialog
                                                            v-model="showDialogCustomItemImages"
                                                            transition="dialog-top-transition"
                                                            persistent
                                                            width="1000"
                                                            :fullscreen="$vuetify.breakpoint.mobile"
                                                        >
                                                            <v-card>
                                                                <v-card-title class="text-h5 lighten-2 formDialog" style="border-bottom: solid 1px var(--color__cinza)">
                                                                    Upload Images
                                                                </v-card-title>

                                                                <v-card-text style="margin-top: 20px;">
                                                                    
                                                                    <v-row>
                                                                        <v-col
                                                                            cols="12"
                                                                        >
                                                                            <canvas id="canvas" hidden></canvas>
                                                                            <label>Photos</label>
                                                                            <v-file-input
                                                                                v-model="customItemFilesPhotos" 
                                                                                accept="image/*"
                                                                                small-chips
                                                                                multiple
                                                                                outlined
                                                                                placeholder="Click here to add"
                                                                                prepend-inner-icon="mdi-paperclip"
                                                                                prepend-icon=""
                                                                                @change="resizePreviewImage(customItemFilesPhotos, customItemPhotos)"
                                                                            ></v-file-input>
                                                                        </v-col>
                                                                    </v-row>
                                                                    <v-row>
                                                                        <v-col
                                                                            v-for="(itemPhoto, index) in customItemPhotos.filter(pht => pht.deleted == false)"
                                                                            :key="index"
                                                                            cols="12"
                                                                            lg="2"
                                                                            md="4"
                                                                            sm="12"
                                                                        >
                                                                            <v-card max-width="200">
                                                                                <v-img
                                                                                    :src="itemPhoto.src"
                                                                                    :lazy-src="itemPhoto.src"
                                                                                    aspect-ratio="1"
                                                                                    max-height="200"
                                                                                    max-width="200"
                                                                                    style="cursor: pointer;"
                                                                                    @click="downloadFile(URL_ATTACHMENT, itemPhoto.id, itemPhoto.fileType, itemPhoto.fileNameComplete)"
                                                                                >
                                                                                    <template v-slot:placeholder>
                                                                                    <v-row
                                                                                        class="fill-height ma-0"
                                                                                        align="center"
                                                                                        justify="center"
                                                                                    >
                                                                                        <v-progress-circular
                                                                                            indeterminate
                                                                                            color="grey lighten-5"
                                                                                        ></v-progress-circular>
                                                                                    </v-row>
                                                                                    </template>
                                                                                </v-img>
                                                                                <span class="imageFileName">{{ itemPhoto.fileName }}</span>
                                                                                <v-icon class="deletePhotoIcon" small right color="var(--color__red)" @click="confirmPhotoDelete(itemPhoto)">mdi mdi-delete</v-icon>
                                                                            </v-card>
                                                                        </v-col>
                                                                    </v-row>
                                                                    
                                                                </v-card-text>

                                                                <v-divider></v-divider>

                                                                <v-card-actions>
                                                                    <div style="width: 100%; text-align: center;">
                                                                        <v-btn
                                                                            class="mx-2 buttonCancelDialog"
                                                                            style=""
                                                                            outlined
                                                                            @click="showDialogCustomItemImages = false"
                                                                        >
                                                                            Cancel
                                                                        </v-btn>

                                                                        <v-btn
                                                                            class="mx-2"
                                                                            outlined
                                                                            @click="saveItemCustomImages()"
                                                                        >
                                                                            Save
                                                                        </v-btn>
                                                                    </div>
                                                                </v-card-actions>
                                                            </v-card>
                                                        </v-dialog>
                                                    </v-card>                                                    
                                                </v-card-text>
                                            </v-col>
                                        </v-row>  
                                    </v-card-text>

                                </v-card>

                            </v-card-text>
                        </v-col>
                    </v-row>
                    
                    <v-row 
                        v-if="projectSelected != null && projectSelected != undefined"
                    >
                        <v-col
                            cols="12"
                            lg="12"
                            md="12"
                            sm="12"
                            style="padding: 20px;"
                        >
                            <v-card-text>

                                <v-card
                                    class="mx-auto"
                                > 
                                    <v-card-text>
                                        <v-row>
                                            <v-col
                                                style="padding-left: 0px !important; text-align: right;"
                                            >
                                                <label style="font-size: 30px !important; color: var(--color__main);">
                                                    {{ grandAllTotal }}
                                                </label>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </v-card-text>
                        </v-col>
                    </v-row>
                </v-stepper-content>

                <!-- STEP 2: CHECK PRICES  -->
                <v-stepper-content step="2">
                                        
                    <!-- PRODUCTS -->
                    <v-row 
                        v-if="projectSelected != null && projectSelected != undefined"
                    >
                        <v-col
                            cols="12"
                            style="padding: 0px !important;"
                        >
                            <v-card-text>

                                <v-card
                                    class="mx-auto"
                                >
                                    <v-card-title class="text-h5 lighten-2" style="border-bottom: solid 1px var(--color__cinza)">
                                        <v-row>
                                            <v-col
                                                cols="9"
                                            >
                                                Selected Items
                                            </v-col>
                                            <v-col
                                                style="text-align:right;"
                                                cols="3"
                                            >
                                                <v-tooltip top v-if="!showMoreDetailProducts">
                                                    <template v-slot:activator="{ on }">
                                                        <v-icon v-on="on" @click="showMoreDetailProducts = true"  v-if="!showMoreDetailProducts">mdi-eye-off</v-icon>
                                                    </template>
                                                    <span>See more details</span>
                                                </v-tooltip>
                                                <v-tooltip top v-if="showMoreDetailProducts">
                                                    <template v-slot:activator="{ on }">
                                                        <v-icon v-on="on" @click="showMoreDetailProducts = false" v-if="showMoreDetailProducts">mdi-eye</v-icon>
                                                    </template>
                                                    <span>Hide more details</span>
                                                </v-tooltip>
                                            </v-col>
                                        </v-row>
                                    </v-card-title>
                                    <v-card-text style="margin-top: 20px;">
                                        <v-simple-table
                                            fixed-header
                                        >
                                            <template v-slot:default>
                                                <thead>
                                                    <tr>
                                                        <th class="text-left" style="width: 20%">
                                                            Category / Sub Category
                                                        </th>
                                                        <th class="text-left" style="width: 20%">
                                                            Product
                                                        </th>
                                                        <th class="text-left" style="width: 30%">
                                                            Description
                                                        </th>
                                                        <th class="text-center" style="width: 10%">
                                                            Qty
                                                        </th>
                                                        <th class="text-right" style="width: 10%" v-if="showMoreDetailProducts">
                                                            Price
                                                        </th>
                                                        <th class="text-right" style="width: 10%" v-if="showMoreDetailProducts">
                                                            Total
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr
                                                        v-for="(item, index) in listProductSelecteds.filter(prd => prd.automation == false || prd.notAutomatable == 1)" :key="index"
                                                    >
                                                        <td>{{ item.categoryDescription }} {{ item.subCategoryDescription != null && item.subCategoryDescription != undefined && item.subCategoryDescription != '' ? ' / ' + item.subCategoryDescription : '' }}</td>
                                                        <td>{{ item.productDescription }}</td>
                                                        <td>{{ item.productDetails }}</td>
                                                        <td class="text-center">{{ item.qty }} <span style="font-size: 10px; font-weight: bold;">{{ item.unitySymbol }}</span></td>
                                                        <td class="text-right" v-if="showMoreDetailProducts">$ {{ item.price }}</td>
                                                        <td class="text-right" v-if="showMoreDetailProducts">$ {{ item.total }}</td>
                                                    </tr>
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                    </v-card-text>
                                </v-card>
                                
                            </v-card-text>
                        </v-col>

                        <v-col
                            v-if="qtyChannels > 0"
                            cols="12"
                            style="padding: 0px !important;"
                        >
                            <v-card-text>

                                <v-card
                                    class="mx-auto"
                                >
                                    <v-card-title class="text-h5 lighten-2" style="border-bottom: solid 1px var(--color__cinza)">
                                        Automation
                                    </v-card-title>

                                    <v-card-text 
                                        style="margin-top: 20px;"
                                    >
                                        <label>Automation Controller</label>

                                        <v-simple-table
                                            fixed-header
                                        >
                                            <template v-slot:default>
                                                <thead>
                                                    <tr>
                                                        <th class="text-left" style="width: 20%">
                                                            Category / Sub Category
                                                        </th>
                                                        <th class="text-left" style="width: 20%">
                                                            Product
                                                        </th>
                                                        <th class="text-left" style="width: 30%">
                                                            Description
                                                        </th>
                                                        <th class="text-center" style="width: 10%">
                                                            Qty
                                                        </th>
                                                        <th class="text-right" style="width: 10%" v-if="showMoreDetailProducts">
                                                            Price
                                                        </th>
                                                        <th class="text-right" style="width: 10%" v-if="showMoreDetailProducts">
                                                            Total
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr
                                                        v-for="(item, index) in listProductSelecteds.filter(prd => prd.automationCenter == 1)" :key="index"
                                                    >
                                                        <td>{{ item.categoryDescription }} {{ item.subCategoryDescription != null && item.subCategoryDescription != undefined && item.subCategoryDescription != '' ? ' / ' + item.subCategoryDescription : '' }}</td>
                                                        <td>{{ item.productDescription }}</td>
                                                        <td>{{ item.productDetails }}</td>
                                                        <td class="text-center">{{ item.qty }} <span style="font-size: 10px; font-weight: bold;">{{ item.unitySymbol }}</span></td>
                                                        <td class="text-right" v-if="showMoreDetailProducts">$ {{ item.price }}</td>
                                                        <td class="text-right" v-if="showMoreDetailProducts">$ {{ item.total }}</td>
                                                    </tr>
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                    </v-card-text>

                                    <v-card-text 
                                        style="margin-top: 20px;"
                                        v-if="qtyChannels > 0"
                                    >
                                        <label>Automation Items</label>

                                        <v-simple-table
                                            fixed-header
                                        >
                                            <template v-slot:default>
                                                <thead>
                                                    <tr>
                                                        <th class="text-left" style="width: 20%">
                                                            Category / Sub Category
                                                        </th>
                                                        <th class="text-left" style="width: 20%">
                                                            Product
                                                        </th>
                                                        <th class="text-left" style="width: 30%">
                                                            Description
                                                        </th>
                                                        <th class="text-center" style="width: 10%">
                                                            Qty
                                                        </th>
                                                        <th class="text-right" style="width: 10%" v-if="showMoreDetailProducts">
                                                            Price
                                                        </th>
                                                        <th class="text-right" style="width: 10%" v-if="showMoreDetailProducts">
                                                            Total
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr
                                                        v-for="(item, index) in listProductSelecteds.filter(prd => prd.automatable == 1 && prd.notAutomatable == 0)" :key="index"
                                                    >
                                                        <td>{{ item.categoryDescription }} {{ item.subCategoryDescription != null && item.subCategoryDescription != undefined && item.subCategoryDescription != '' ? ' / ' + item.subCategoryDescription : '' }}</td>
                                                        <td>{{ item.productDescription }}</td>
                                                        <td>{{ item.productDetails }}</td>
                                                        <td class="text-center">{{ item.qty }} <span style="font-size: 10px; font-weight: bold;">{{ item.unitySymbol }}</span></td>
                                                        <td class="text-right" v-if="showMoreDetailProducts">$ {{ item.price }}</td>
                                                        <td class="text-right" v-if="showMoreDetailProducts">$ {{ item.total }}</td>
                                                    </tr>
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                    </v-card-text>
                                </v-card>
                                
                            </v-card-text>
                        </v-col>

                        <v-col
                            v-if="hasCustomItems == true"
                            cols="12"
                            style="padding: 0px !important;"
                        >
                            <v-card-text>

                                <v-card
                                    class="mx-auto"
                                >
                                    <v-card-title class="text-h5 lighten-2" style="border-bottom: solid 1px var(--color__cinza)">
                                        Custom Items
                                    </v-card-title>

                                    <v-card-text 
                                        style="margin-top: 20px;"
                                    >
                                        <v-simple-table
                                            fixed-header
                                            style="cursor: pointer;"
                                        >
                                            <template v-slot:default>
                                                <thead>
                                                    <tr>
                                                        <th class="text-left" style="width: 40%;" >
                                                            Description
                                                        </th>
                                                        <th class="text-center">
                                                            Qty
                                                        </th>
                                                        <th class="text-left" style="width: 10%">
                                                            Option
                                                        </th>
                                                        <th v-if="showMoreDetailProducts">
                                                            Price
                                                        </th>
                                                        <th v-if="showMoreDetailProducts">
                                                            Total
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr
                                                        v-for="(item, index) in listCustomItems" :key="index"
                                                    >
                                                        <td>{{ item.description }}</td>
                                                        <td class="text-center">{{ item.qty }}</td>
                                                        <td>{{ item.optionalDescription }}</td>
                                                        <td v-if="showMoreDetailProducts">$ {{ item.priceFormatted }}</td>
                                                        <td v-if="showMoreDetailProducts">$ {{ item.total }}</td>
                                                    </tr>
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                    </v-card-text>
                                </v-card>
                                
                            </v-card-text>
                        </v-col>

                        <v-col
                            cols="12"
                            style="padding: 0px !important;"
                        >
                            <v-card-text>

                                <v-card
                                    class="mx-auto"
                                >
                                    <v-card-title class="text-h5 lighten-2" style="border-bottom: solid 1px var(--color__cinza)">
                                        <v-row>
                                            <v-col
                                                cols="9"
                                            >
                                                Totals
                                            </v-col>
                                        </v-row>
                                    </v-card-title>
                                    <v-card-text style="margin-top: 20px;">
                                        <v-simple-table
                                            fixed-header
                                        >
                                            <template v-slot:default>
                                                <thead>
                                                    <tr>
                                                        <th class="text-left" style="width: 20%">
                                                            
                                                        </th>
                                                        <th class="text-left" style="width: 20%">
                                                            
                                                        </th>
                                                        <th class="text-left" style="width: 30%">
                                                            
                                                        </th>
                                                        <th class="text-center" style="width: 10%">
                                                            
                                                        </th>
                                                        <th class="text-right" style="width: 10%" v-if="showMoreDetailProducts">
                                                            Price
                                                        </th>
                                                        <th class="text-right" style="width: 10%" v-if="showMoreDetailProducts">
                                                            Total
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tfoot>
                                                    <tr v-if="hasCustomItems == true">
                                                        <th class="text-left"></th>
                                                        <th class="text-left"></th>
                                                        <th class="text-center" v-if="showMoreDetailProducts"></th>
                                                        <th class="text-right" v-if="showMoreDetailProducts"></th>
                                                        <th class="text-right" style="color: var(--color__main); font-size: 20px; height: 50px !important; ">
                                                            Selected Items
                                                        </th>
                                                        <th 
                                                            class="text-right" 
                                                            style="color: var(--color__main); font-size: 20px;"
                                                        >
                                                            {{ selectedTotalProducts }}
                                                        </th>
                                                    </tr>
                                                    <tr v-if="hasCustomItems == true">
                                                        <th class="text-left"></th>
                                                        <th class="text-left"></th>
                                                        <th class="text-center" v-if="showMoreDetailProducts"></th>
                                                        <th class="text-right" v-if="showMoreDetailProducts"></th>
                                                        <th class="text-right" style="color: var(--color__main); font-size: 20px; height: 50px !important; ">
                                                            Custom Items
                                                        </th>
                                                        <th 
                                                            class="text-right" 
                                                            style="color: var(--color__main); font-size: 20px;"
                                                        >
                                                            {{ grandTotalProductsCustomItems.formatted }}
                                                        </th>
                                                    </tr>
                                                    <tr>
                                                        <th class="text-left"></th>
                                                        <th class="text-left"></th>
                                                        <th class="text-center" v-if="showMoreDetailProducts"></th>
                                                        <th class="text-right" v-if="showMoreDetailProducts"></th>
                                                        <th class="text-right" style="color: var(--color__main); font-size: 20px; height: 50px !important; ">
                                                            Permit Fee
                                                        </th>
                                                        <th 
                                                            class="text-right" 
                                                            style="color: var(--color__main); font-size: 20px;"
                                                        >
                                                            {{ serviceRequest.permitFeeFormatted }} %
                                                        </th>
                                                    </tr>
                                                    <tr v-if="showMoreDetailProducts">
                                                        <th class="text-left"></th>
                                                        <th class="text-left"></th>
                                                        <th class="text-center"></th>
                                                        <th class="text-right"></th>
                                                        <th class="text-right" style="color: var(--color__main); font-size: 20px; height: 50px !important; ">
                                                            Discount
                                                        </th>
                                                        <th
                                                            style="display: flex;"
                                                        >
                                                            <v-text-field
                                                                name="discount"
                                                                v-model="discount"
                                                                v-formatMoney="moneyFormat"
                                                                :rules=[validations.required]
                                                                single-line
                                                                outlined
                                                                dense
                                                                @blur="calculateTotal('d')"
                                                            >
                                                            </v-text-field>
                                                        </th>
                                                    </tr>
                                                    <tr>
                                                        <th class="text-left"></th>
                                                        <th class="text-left"></th>
                                                        <th class="text-center" v-if="showMoreDetailProducts"></th>
                                                        <th class="text-right" v-if="showMoreDetailProducts"></th>
                                                        <th class="text-right" style="color: var(--color__main); font-size: 20px; height: 50px !important;">
                                                            Grand Total
                                                        </th>
                                                        <th
                                                            class="text-right" 
                                                            style="color: var(--color__main); font-size: 20px;"
                                                        >
                                                            {{ grandAllTotal }}
                                                        </th>
                                                    </tr>
                                                    <tr v-if="showMoreDetailProducts">
                                                        <th class="text-left"></th>
                                                        <th class="text-left"></th>
                                                        <th class="text-center"></th>
                                                        <th class="text-right"></th>
                                                        <th class="text-right" style="color: var(--color__main); font-size: 20px; height: 50px !important;">
                                                            Adjustment
                                                        </th>
                                                        <th
                                                            style="display: flex;"
                                                        >
                                                            <v-text-field
                                                                name="grandTotal"
                                                                v-model="serviceRequest.adjustmentFormatted" 
                                                                v-formatMoney="moneyFormat"
                                                                single-line
                                                                outlined
                                                                dense
                                                                @blur="calculateTotal('v')"
                                                            >
                                                            </v-text-field>
                                                        </th>
                                                    </tr>
                                                    <tr v-if="showMoreDetailProducts">
                                                        <th class="text-left"></th>
                                                        <th class="text-left"></th>
                                                        <th class="text-center" v-if="showMoreDetailProducts"></th>
                                                        <th class="text-right"  v-if="showMoreDetailProducts"></th>
                                                        <th class="text-right"  style="color: var(--color__main); font-size: 20px; height: 50px !important;">
                                                            Budget
                                                        </th>
                                                        <th class="text-right"  style="width: 15%; color: var(--color__main); font-size: 20px;">
                                                            {{ serviceRequest.estimatedBudgetFormatted }}
                                                        </th>
                                                    </tr>
                                                    <tr v-if="showMoreDetailProducts">
                                                        <th class="text-left"></th>
                                                        <th class="text-left"></th>
                                                        <th class="text-center" v-if="showMoreDetailProducts"></th>
                                                        <th class="text-right"  v-if="showMoreDetailProducts"></th>
                                                        <th class="text-right"  style="color: var(--color__main); font-size: 20px; height: 50px !important;">
                                                            Zillow
                                                        </th>
                                                        <th class="text-right"  style="color: var(--color__main); font-size: 20px;">
                                                            {{ estimatedValueZillow }}
                                                        </th>
                                                    </tr>
                                                </tfoot>
                                            </template>
                                        </v-simple-table>
                                    </v-card-text>
                                </v-card>
                                
                            </v-card-text>
                        </v-col>
                    </v-row>

                    <v-row v-if="showMoreDetailProducts">
                        <v-col
                            cols="12"
                            lg="7"
                            md="12"
                            sm="12"
                        >
                            &nbsp;
                        </v-col>
                        <v-col
                            cols="12"
                            lg="5"
                            md="12"
                            sm="12"
                        >
                            <zillowTerms :address="serviceRequest.addressSelected.address" :lgWidthTerms="'8'" :lgWidthLogo="'4'"  />
                        </v-col>
                    </v-row>

                </v-stepper-content>

                <!-- STEP 3: PROPOSAL  -->
                <v-stepper-content step="3">
                    
                    <!-- PRODUCT -->
                    <v-row>
                        <v-col
                            cols="12"
                            style="padding: 0px !important;"
                        >
                            <v-card-text>

                                <v-card
                                    class="mx-auto"
                                >
                                    <v-card-title class="text-h5 lighten-2" style="border-bottom: solid 1px var(--color__cinza)">
                                        Selected Items
                                    </v-card-title>
                                    <v-card-text style="margin-top: 20px;">
                                        <v-simple-table
                                            fixed-header
                                            style="cursor: pointer;"
                                        >
                                            <template v-slot:default>
                                                <thead>
                                                    <tr>
                                                        <th class="text-left" style="width: 20%">
                                                            Category / Sub Category
                                                        </th>
                                                        <th class="text-left" style="width: 20%">
                                                            Product
                                                        </th>
                                                        <th class="text-left" style="width: 50%">
                                                            Description
                                                        </th>
                                                        <th class="text-right" style="width: 10%">
                                                            Qty
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr
                                                        v-for="(item, index) in listProductSelecteds.filter(prd => prd.automation == false || prd.notAutomatable == 1)" :key="index"
                                                    >
                                                        <td>{{ item.categoryDescription }} {{ item.subCategoryDescription != null && item.subCategoryDescription != undefined && item.subCategoryDescription != '' ? ' / ' + item.subCategoryDescription : '' }}</td>
                                                        <td>{{ item.productDescription }}</td>
                                                        <td>{{ item.productDetails }}</td>
                                                        <td class="text-right">{{ item.qty }} <span style="font-size: 10px; font-weight: bold;">{{ item.unitySymbol }}</span></td>
                                                    </tr>
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                    </v-card-text>
                                </v-card>                                
                            </v-card-text>
                        </v-col>

                        <v-col
                            v-if="qtyChannels > 0"
                            cols="12"
                            style="padding: 0px !important;"
                        >

                            <v-card-text>

                                <v-card
                                    class="mx-auto"
                                >
                                    <v-card-title class="text-h5 lighten-2" style="border-bottom: solid 1px var(--color__cinza)">
                                        Automation
                                    </v-card-title>
                                    <v-card-text style="margin-top: 20px;">
                                        
                                        <label>Automation Controller</label>

                                        <v-simple-table
                                            fixed-header
                                            style="cursor: pointer;"
                                        >
                                            <template v-slot:default>
                                                <thead>
                                                    <tr>
                                                        <th class="text-left" style="width: 20%">
                                                            Category / Sub Category
                                                        </th>
                                                        <th class="text-left" style="width: 20%">
                                                            Product
                                                        </th>
                                                        <th class="text-left" style="width: 50%">
                                                            Description
                                                        </th>
                                                        <th class="text-right" style="width: 10%">
                                                            Qty
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr
                                                        v-for="(item, index) in listProductSelecteds.filter(prd => prd.automationCenter == 1)" :key="index"
                                                    >
                                                        <td>{{ item.categoryDescription }} {{ item.subCategoryDescription != null && item.subCategoryDescription != undefined && item.subCategoryDescription != '' ? ' / ' + item.subCategoryDescription : '' }}</td>
                                                        <td>{{ item.productDescription }}</td>
                                                        <td>{{ item.productDetails }}</td>
                                                        <td class="text-right">{{ item.qty }} <span style="font-size: 10px; font-weight: bold;">{{ item.unitySymbol }}</span></td>
                                                    </tr>
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                    </v-card-text>

                                    <v-card-text style="margin-top: 20px;">
                                        
                                        <label>Automation Items</label>

                                        <v-simple-table
                                            fixed-header
                                            style="cursor: pointer;"
                                        >
                                            <template v-slot:default>
                                                <thead>
                                                    <tr>
                                                        <th class="text-left" style="width: 20%">
                                                            Category / Sub Category
                                                        </th>
                                                        <th class="text-left" style="width: 20%">
                                                            Product
                                                        </th>
                                                        <th class="text-left" style="width: 50%">
                                                            Description
                                                        </th>
                                                        <th class="text-right" style="width: 10%">
                                                            Qty
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr
                                                        v-for="(item, index) in listProductSelecteds.filter(prd => prd.automatable == 1 && prd.notAutomatable == 0)" :key="index"
                                                    >
                                                        <td>{{ item.categoryDescription }} {{ item.subCategoryDescription != null && item.subCategoryDescription != undefined && item.subCategoryDescription != '' ? ' / ' + item.subCategoryDescription : '' }}</td>
                                                        <td>{{ item.productDescription }}</td>
                                                        <td>{{ item.productDetails }}</td>
                                                        <td class="text-right">{{ item.qty }} <span style="font-size: 10px; font-weight: bold;">{{ item.unitySymbol }}</span></td>
                                                    </tr>
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                    </v-card-text>
                                </v-card>
                                
                            </v-card-text>
                        </v-col>

                        <v-col
                            v-if="hasCustomItems == true"
                            cols="12"
                            style="padding: 0px !important;"
                        >
                            <v-card-text>

                                <v-card
                                    class="mx-auto"
                                >
                                    <v-card-title class="text-h5 lighten-2" style="border-bottom: solid 1px var(--color__cinza)">
                                        Custom Items
                                    </v-card-title>

                                    <v-card-text 
                                        style="margin-top: 20px;"
                                    >
                                        <v-simple-table
                                            fixed-header
                                            style="cursor: pointer;"
                                        >
                                            <template v-slot:default>
                                                <thead>
                                                    <tr>
                                                        <th class="text-left" style="width: 40%;" >
                                                            Description
                                                        </th>
                                                        <th class="text-center">
                                                            Qty
                                                        </th>
                                                        <th class="text-left" style="width: 10%">
                                                            Option
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr
                                                        v-for="(item, index) in listCustomItems" :key="index"
                                                    >
                                                        <td>{{ item.description }}</td>
                                                        <td class="text-center">{{ item.qty }}</td>
                                                        <td>{{ item.optionalDescription }}</td>
                                                    </tr>
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                    </v-card-text>
                                </v-card>
                                
                            </v-card-text>
                        </v-col>
                        
                        <v-col
                            cols="12"
                            style="padding: 0px !important;"
                        >
                            <v-card-text>

                                <v-card
                                    class="mx-auto"
                                >
                                    <v-card-title class="text-h5 lighten-2" style="border-bottom: solid 1px var(--color__cinza)">
                                        Totals
                                    </v-card-title>
                                    <v-card-text style="margin-top: 20px;">
                                        <v-simple-table
                                            fixed-header
                                            style="cursor: pointer;"
                                        >
                                            <template v-slot:default>
                                                <thead>
                                                    <tr>
                                                        <th class="text-left" style="width: 20%">
                                                            
                                                        </th>
                                                        <th class="text-left" style="width: 20%">
                                                            
                                                        </th>
                                                        <th class="text-left" style="width: 50%">
                                                            
                                                        </th>
                                                        <th class="text-right" style="width: 10%">
                                                            
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tfoot>
                                                    <tr>
                                                        <th class="text-left"></th>
                                                        <th class="text-left"></th>
                                                        <th class="text-right" style="color: var(--color__main); font-size: 20px;">
                                                            Selected Items
                                                        </th>
                                                        <th class="text-right" style="color: var(--color__main); font-size: 20px;">
                                                            {{ selectedTotalProducts }}
                                                        </th>
                                                    </tr>
                                                    <tr>
                                                        <th class="text-left"></th>
                                                        <th class="text-left"></th>
                                                        <th class="text-right" style="color: var(--color__main); font-size: 20px;">
                                                            Custom Items
                                                        </th>
                                                        <th class="text-right" style="color: var(--color__main); font-size: 20px;">
                                                            {{ grandTotalProductsCustomItems.formatted }}
                                                        </th>
                                                    </tr>
                                                    <tr>
                                                        <th class="text-left"></th>
                                                        <th class="text-left"></th>
                                                        <th class="text-right" style="color: var(--color__main); font-size: 20px;">
                                                            Permit Fee
                                                        </th>
                                                        <th class="text-right" style="color: var(--color__main); font-size: 20px;">
                                                            {{ serviceRequest.permitFeeFormatted }} %
                                                        </th>
                                                    </tr>
                                                    <tr>
                                                        <th class="text-left"></th>
                                                        <th class="text-left"></th>
                                                        <th class="text-right" style="color: var(--color__main); font-size: 20px;">
                                                            Discount
                                                        </th>
                                                        <th class="text-right" style="color: var(--color__main); font-size: 20px;">
                                                            {{ discount }}
                                                        </th>
                                                    </tr>
                                                    <tr>
                                                        <th class="text-left"></th>
                                                        <th class="text-left"></th>
                                                        <th class="text-right" style="color: var(--color__main); font-size: 20px;">
                                                            Grand Total
                                                        </th>
                                                        <th class="text-right" style="color: var(--color__main); font-size: 20px;">
                                                            {{ grandAllTotal }}
                                                        </th>
                                                    </tr>
                                                </tfoot>
                                            </template>
                                        </v-simple-table>
                                    </v-card-text>

                                </v-card>
                                
                            </v-card-text>
                        </v-col>
                    </v-row>

                    <v-row>
                        <!-- SCOPE OF WORK -->
                        <v-col
                            v-if="serviceRequest.status == 6"
                            cols="12"
                            style="padding: 0px !important;"
                        >
                            <v-card-text>

                                <v-card
                                    class="mx-auto"
                                >
                                    <v-card-title class="text-h5 lighten-2" style="border-bottom: solid 1px var(--color__cinza)">
                                        <v-col cols="4">
                                            Scope of Work
                                        </v-col>
                                        <v-col cols="8" style="text-align: right;">
                                            <v-chip
                                                style="font-size: 12px !important;"
                                                :color="statusColorScopeOfWork"
                                                outlined
                                                dark
                                            >
                                                {{ statusDescriptionScopeOfWork }}
                                            </v-chip>

                                            <v-tooltip top>
                                                <template v-slot:activator="{ on }">
                                                    <v-chip
                                                        style="font-size: 12px !important; margin-left: 10px;"
                                                        v-on="on"
                                                        color="primary"
                                                        outlined
                                                        dark
                                                        link
                                                        @click="showDialogDocusign(TYPE_DOCUMENT.PROPOSAL)"
                                                    >
                                                        Docusign
                                                    </v-chip>
                                                </template>
                                                <span>Click to view docusign options</span>
                                            </v-tooltip>
                                        </v-col>
                                    </v-card-title>
                                    <v-card-text style="margin-top: 20px;">
                                        <v-row>
                                            <v-col
                                                cols="12"
                                                lg="5"
                                                md="12"
                                                sm="12"
                                            >
                                                <span><strong>Step 1:</strong> You must download the proposal and send it to the customer for signing</span>
                                                <v-tooltip top>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            style="width: 100% !important; margin-top: 2rem; margin-left: 0px !important;"
                                                            class="mx-2"
                                                            v-on="on"
                                                            @click="showDialogTotalProposal = true;"
                                                        >
                                                            <v-icon left>mdi-file-download-outline</v-icon>
                                                            Download
                                                        </v-btn>
                                                    </template>
                                                    <span>Download PDF</span>
                                                </v-tooltip>

                                            </v-col>
                                            <v-col
                                                style="text-align: center;"
                                                cols="12"
                                                lg="2"
                                                md="12"
                                                sm="12"
                                            >
                                            
                                                <v-divider vertical></v-divider>

                                            </v-col>

                                            <v-col
                                                cols="12"
                                                lg="5"
                                                md="12"
                                                sm="12"
                                            >
                                                <span><strong>Step 2:</strong> Upload the proposal signed to complete this process and proceed to the technical specification phase</span>
                                                
                                                <v-tooltip top>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            style="width: 100% !important; margin-top: 2rem; margin-left: 0px !important;"
                                                            class="mx-2"
                                                            v-on="on"
                                                            @click="uploadSignedScopeOfWork()"
                                                        >
                                                            <v-icon left>mdi-file-upload-outline</v-icon>
                                                            Upload Signed Document
                                                        </v-btn>
                                                    </template>
                                                    <span>Upload Signed Document</span>
                                                </v-tooltip>
                                            </v-col>
                                        </v-row>
                                        
                                    </v-card-text>

                                </v-card>
                                
                            </v-card-text>
                        </v-col>

                        <!-- HOMEOWNER RESPONSABILITY -->
                        <v-col
                            v-if="serviceRequest.status == 6"
                            cols="12"
                            style="padding: 0px !important;"
                        >
                            <v-card-text>

                                <v-card
                                    class="mx-auto"
                                >
                                    <v-card-title class="text-h5 lighten-2" style="border-bottom: solid 1px var(--color__cinza)">
                                        <v-col cols="4">
                                            Homeowner`s Responsibility
                                        </v-col>
                                        <v-col cols="8" style="text-align: right;">
                                            <v-chip
                                                style="font-size: 12px !important;"
                                                :color="statusColorHOResp"
                                                outlined
                                                dark
                                            >
                                                {{ statusDescriptionHOResp }}
                                            </v-chip>

                                            <v-tooltip top>
                                                <template v-slot:activator="{ on }">
                                                    <v-chip
                                                        style="font-size: 12px !important; margin-left: 10px;"
                                                        v-on="on"
                                                        color="primary"
                                                        outlined
                                                        dark
                                                        link
                                                        @click="showDialogDocusign(TYPE_DOCUMENT.HOMEOWNER_RESPONSABILITY)"
                                                    >
                                                        Docusign
                                                    </v-chip>
                                                </template>
                                                <span>Click to view docusign options</span>
                                            </v-tooltip>
                                        </v-col>                                        
                                    </v-card-title>
                                    <v-card-text style="margin-top: 20px;">
                                        <v-row>
                                            <v-col
                                                cols="12"
                                                lg="4"
                                                md="12"
                                                sm="12"
                                            >
                                                <span><strong>Step 1:</strong> Complete the homeowner responsibility form</span>
                                                <v-tooltip top>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            style="width: 100% !important; margin-top: 2rem; margin-left: 0px !important;"
                                                            class="mx-2"
                                                            v-on="on"
                                                            @click="showDialogHO()"
                                                        >
                                                            <v-icon left>mdi-file-download-outline</v-icon>
                                                            Open form
                                                        </v-btn>
                                                    </template>
                                                    <span>Open form</span>
                                                </v-tooltip>
                                            </v-col>

                                            <v-col
                                                cols="12"
                                                lg="4"
                                                md="12"
                                                sm="12"
                                            >
                                                <span><strong>Step 2:</strong> Download the form document</span>
                                                
                                                <v-tooltip top>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            style="width: 100% !important; margin-top: 2rem; margin-left: 0px !important;"
                                                            class="mx-2"
                                                            v-on="on"
                                                            @click="downloadFile(URL_ATTACHMENT_HOMEOWNER_RESPONSABILITY, id, 'application/pdf', 'HomeownerResponsibility.pdf');"
                                                        >
                                                            <v-icon left>mdi-file-download-outline</v-icon>
                                                            Download
                                                        </v-btn>
                                                    </template>
                                                    <span>Download Document</span>
                                                </v-tooltip>
                                            </v-col>

                                            <v-col
                                                cols="12"
                                                lg="4"
                                                md="12"
                                                sm="12"
                                            >
                                                <span><strong>Step 3:</strong> Upload the form signed</span>
                                                
                                                <v-tooltip top>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            style="width: 100% !important; margin-top: 2rem; margin-left: 0px !important;"
                                                            class="mx-2"
                                                            v-on="on"
                                                            @click="uploadSignedHomeownerResponsability()"
                                                        >
                                                            <v-icon left>mdi-file-upload-outline</v-icon>
                                                            Upload Signed Document
                                                        </v-btn>
                                                    </template>
                                                    <span>Upload Signed Document</span>
                                                </v-tooltip>
                                            </v-col>
                                        </v-row>
                                        
                                    </v-card-text>

                                </v-card>
                                
                            </v-card-text>
                        </v-col>

                        <!-- EXCAVATION GUIDE -->
                        <v-col
                            v-if="serviceRequest.status == 6"
                            cols="12"
                            style="padding: 0px !important;"
                        >
                            <v-card-text>

                                <v-card
                                    class="mx-auto"
                                >
                                    <v-card-title class="text-h5 lighten-2" style="border-bottom: solid 1px var(--color__cinza)">
                                        <v-col cols="4">
                                            Excavation Guide
                                        </v-col>
                                        <v-col cols="8" style="text-align: right;">
                                            <v-chip
                                                style="font-size: 12px !important;"
                                                :color="statusColorExcavationGuide"
                                                outlined
                                                dark
                                            >
                                                {{ statusDescriptionExcavationGuide }}
                                            </v-chip>

                                            <v-tooltip top>
                                                <template v-slot:activator="{ on }">
                                                    <v-chip
                                                        style="font-size: 12px !important; margin-left: 10px;"
                                                        v-on="on"
                                                        color="primary"
                                                        outlined
                                                        dark
                                                        link
                                                        @click="showDialogDocusign(TYPE_DOCUMENT.EXCAVATION_GUIDE)"
                                                    >
                                                        Docusign
                                                    </v-chip>
                                                </template>
                                                <span>Click to view docusign options</span>
                                            </v-tooltip>
                                        </v-col>
                                    </v-card-title>
                                    <v-card-text style="margin-top: 20px;">
                                        <v-row>
                                            <v-col
                                                cols="12"
                                                lg="5"
                                                md="12"
                                                sm="12"
                                            >
                                                <span><strong>Step 1:</strong> Download the excavation guide and review the conditions with the customer</span>
                                                <v-tooltip top>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            style="width: 100% !important; margin-top: 2rem; margin-left: 0px !important;"
                                                            class="mx-2"
                                                            v-on="on"
                                                            @click="downloadFile(URL_ATTACHMENT_EXCAVATION_GUIDE, id, 'application/pdf', 'VanKirk_Excavation_Guide.pdf');"
                                                        >
                                                            <v-icon left>mdi-file-download-outline</v-icon>
                                                            Download
                                                        </v-btn>
                                                    </template>
                                                    <span>Download PDF</span>
                                                </v-tooltip>
                                            </v-col>

                                            <v-col
                                                style="text-align: center;"
                                                cols="12"
                                                lg="2"
                                                md="12"
                                                sm="12"
                                            >
                                                <v-divider vertical></v-divider>
                                            </v-col>

                                            <v-col
                                                cols="12"
                                                lg="5"
                                                md="12"
                                                sm="12"
                                            >
                                                <span><strong>Step 2:</strong> Upload the signed excavation guide after customer acknowledgment</span>

                                                <v-tooltip top>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            style="width: 100% !important; margin-top: 2rem; margin-left: 0px !important;"
                                                            class="mx-2"
                                                            v-on="on"
                                                            @click="uploadSignedExcavationGuide()"
                                                        >
                                                            <v-icon left>mdi-file-upload-outline</v-icon>
                                                            Upload Signed Document
                                                        </v-btn>
                                                    </template>
                                                    <span>Upload Signed Document</span>
                                                </v-tooltip>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </v-card-text>
                        </v-col>

                        <!-- CONTRACT -->
                        <v-col
                            v-if="serviceRequest.status == 6"
                            cols="12"
                            style="padding: 0px !important;"
                        >
                            <v-card-text>

                                <v-card
                                    class="mx-auto"
                                >
                                    <v-card-title class="text-h5 lighten-2" style="border-bottom: solid 1px var(--color__cinza)">
                                        <v-col cols="4">
                                            Contract
                                        </v-col>
                                        <v-col cols="8" style="text-align: right;">
                                            <v-chip
                                                style="font-size: 12px !important;"
                                                :color="statusColorContract"
                                                outlined
                                                dark
                                            >
                                                {{ statusDescriptionContract }}
                                            </v-chip>

                                            <v-tooltip top>
                                                <template v-slot:activator="{ on }">
                                                    <v-chip
                                                        style="font-size: 12px !important; margin-left: 10px;"
                                                        v-on="on"
                                                        color="primary"
                                                        outlined
                                                        dark
                                                        link
                                                        @click="showDialogDocusign(TYPE_DOCUMENT.CONTRACT)"
                                                    >
                                                        Docusign
                                                    </v-chip>
                                                </template>
                                                <span>Click to view docusign options</span>
                                            </v-tooltip>
                                        </v-col>
                                    </v-card-title>
                                    <v-card-text style="margin-top: 20px;">
                                        <v-row>
                                            <v-col
                                                v-if="isAdminProfile"
                                                cols="12"
                                                lg="4"
                                                md="12"
                                                sm="12"
                                            >
                                                <span><strong>Step 1:</strong> Complete the homeowner responsibility form</span>
                                                <v-tooltip top>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            style="width: 100% !important; margin-top: 2rem; margin-left: 0px !important;"
                                                            class="mx-2"
                                                            v-on="on"
                                                            @click="showDialogAdditionalInfoContract()"
                                                        >
                                                            <v-icon left>mdi-file-download-outline</v-icon>
                                                            Add additional information
                                                        </v-btn>
                                                    </template>
                                                    <span>Add additional information to the contract</span>
                                                </v-tooltip>
                                            </v-col>

                                            <v-col
                                                cols="12"
                                                :lg="isAdminProfile == true ? 4 : 5"
                                                md="12"
                                                sm="12"
                                            >
                                                <span><strong>{{ isAdminProfile ? 'Step 2:' : 'Step 1:' }}</strong> First you must download the contract and send it to the customer for signing</span>
                                                <v-tooltip top>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            style="width: 100% !important; margin-top: 2rem; margin-left: 0px !important;"
                                                            class="mx-2"
                                                            v-on="on"
                                                            @click="downloadFile(URL_ATTACHMENT_CONTRACT, id, 'application/pdf', 'Contract.pdf');"
                                                        >
                                                            <v-icon left>mdi-file-download-outline</v-icon>
                                                            Download
                                                        </v-btn>
                                                    </template>
                                                    <span>Download PDF</span>
                                                </v-tooltip>

                                            </v-col>

                                            <v-col
                                                v-if="isAdminProfile == false"
                                                style="text-align: center;"
                                                cols="12"
                                                lg="2"
                                                md="12"
                                                sm="12"
                                            >                                            
                                                <v-divider vertical></v-divider>
                                            </v-col>

                                            <v-col
                                                cols="12"
                                                :lg="isAdminProfile == true ? 4 : 5"
                                                md="12"
                                                sm="12"
                                            >
                                                <span><strong>{{ isAdminProfile ? 'Step 3:' : 'Step 2:' }}</strong> Upload the contract signed</span>
                                                
                                                <v-tooltip top>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            style="width: 100% !important; margin-top: 2rem; margin-left: 0px !important;"
                                                            class="mx-2"
                                                            v-on="on"
                                                            @click="uploadSignedContract()"
                                                        >
                                                            <v-icon left>mdi-file-upload-outline</v-icon>
                                                            Upload Signed Document
                                                        </v-btn>
                                                    </template>
                                                    <span>Upload Signed Document</span>
                                                </v-tooltip>
                                            </v-col>
                                        </v-row>
                                        
                                    </v-card-text>

                                </v-card>
                                
                            </v-card-text>
                        </v-col>
                    </v-row>
                </v-stepper-content>

                <!-- STEP 4: TECHNICAL SPECIFICATION -->
                <v-stepper-content step="4">
                    <TechnicalSpecification 
                        :project="projectSelected"
                        :listProjects="listProjects"
                        :showBackButton="false"
                        :showNotificationApprovedOrDenied="false"
                        v-on:cancel="cancel"
                    />

                </v-stepper-content>
            </v-stepper-items>
        </v-stepper>
            

        <v-dialog
            v-model="showDialogTotalProposal"
            transition="dialog-top-transition"
            persistent
            width="800"
            :fullscreen="$vuetify.breakpoint.mobile"
        >
            <v-card>
                <v-card-title class="text-h5 lighten-2 formDialog" style="border-bottom: solid 1px var(--color__cinza)">
                    Download PDF Proposal
                </v-card-title>

                <v-card-text style="margin-top: 20px;">
                    <v-row>
                        <v-col 
                            cols="12"
                            lg="12"
                            md="12"
                            sm="12"
                        >
                            <v-switch 
                                v-model="showTotalProposal"
                                label="Show only the total value of the proposal?"
                                :value=true
                                color="var(--color__main)"
                            >
                            </v-switch>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <div style="width: 100%; text-align: center;">
                        <v-btn
                            class="mx-2 dialogButtonDismiss"
                            style=""
                            outlined
                            @click="showDialogTotalProposal = false"
                        >
                            Dismiss
                        </v-btn>
                        <v-btn
                            class="mx-2"
                            outlined
                            @click="downloadProposal()"
                        >
                            Download
                        </v-btn>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <!-- Buttons: NEXT | BACK -->
        
        <div 
            style="padding-top: 15px;"
            v-if="projectSelected != null && projectSelected != undefined && projectSelected.status > 7"
            class="text-center"
        >
            
            <v-row>
                <v-col 
                    cols="12"
                    lg="12"
                    md="12"
                    sm="12"
                >
                    <v-tooltip top>
                        <template v-slot:activator="{ on }">
                            <v-btn 
                                class="mx-2"
                                v-on="on"
                                style="background-color: var(--color__silver) !important; color: #ffffff !important"
                                @click="back()"
                            >
                                Back
                            </v-btn>
                        </template>
                        <span>Back</span>
                    </v-tooltip>
                </v-col>
            </v-row>
        </div>

        <v-card-actions 
            v-else
            class="justify-center"
            style="padding-top: 50px"
        >
            <v-tooltip 
                v-if="showCancelButton"
                top
            >
                <template v-slot:activator="{ on }">
                    <v-btn 
                        v-if="showCancelButton"
                        class="mx-2"
                        v-on="on"
                        @click="cancel"
                        style="background-color: var(--color__red) !important; color: #ffffff !important;"
                    >
                        Cancel
                    </v-btn>
                </template>
                <span>Cancel</span>
            </v-tooltip>
            
            <v-tooltip 
                v-if="showBackButton"
                top
            >
                <template v-slot:activator="{ on }">
                    <v-btn 
                        v-if="showBackButton"
                        class="mx-2"
                        v-on="on"
                        :disabled="steps == 1 || projectSelected == null || projectSelected == undefined"
                        style="background-color: var(--color__silver) !important; color: #ffffff !important"
                        @click="controlStep('back')"
                    >
                        Back
                    </v-btn>
                </template>
                <span>Back Previous Step</span>
            </v-tooltip>

            <v-tooltip 
                v-if="showNextButton"
                top
            >
                <template v-slot:activator="{ on }">
                    <v-btn
                        v-if="showNextButton"
                        class="mx-2"
                        v-on="on"
                        :disabled="projectSelected == null || projectSelected == undefined"
                        @click="controlStep('next')"
                    >
                        Next
                    </v-btn>
                </template>
                <span>Go To Next Step</span>
            </v-tooltip>            
                    
            <v-tooltip 
                v-if="showDownloadAndCreateProposal"
                top
            >
                <template v-slot:activator="{ on }">
                    <v-btn
                        v-if="showDownloadAndCreateProposal"
                        class="mx-2"
                        v-on="on"
                        @click="showDialogTotalProposal = true;"
                    >
                        Download Proposal
                    </v-btn>
                </template>
                <span>Download a proposal to send to the customer</span>
            </v-tooltip>

            <v-tooltip 
                v-if="showDownloadAndCreateProposal"
                top
            >
                <template v-slot:activator="{ on }">
                    <v-btn
                        v-if="showDownloadAndCreateProposal"
                        class="mx-2"
                        v-on="on"
                        @click="confirmCreateProposal()"
                    >
                        Create Proposal
                    </v-btn>
                </template>
                <span>Create Proposal</span>
            </v-tooltip>

        </v-card-actions>

        <ActionDialog 
            v-on:methodConfirmToCall="dialog.methodConfirm"
            v-on:methodCancelOrDenyToCall="dialog.methodCancelOrDeny"
            :showDialog.sync="dialog.show"
            :headerTitle="dialog.headerText"
            :bodyText="dialog.bodyText"
            :params="dialog.params"
        />

        <UploadFile 
            v-on:methodConfirmAfterUpload="dialogUploadFile.methodAfterUpload"
            :showUploadFile.sync="dialogUploadFile.show"
            :idKey="dialogUploadFile.idKey"
            :reload="dialogUploadFile.reload"
            :acceptType="dialogUploadFile.acceptType"
            :typeAttachment="dialogUploadFile.typeAttachment"
            :typeDocument="dialogUploadFile.typeDocument"
            :multipleFiles="dialogUploadFile.multipleFiles"
            :showMsgConfirmation="dialogUploadFile.showMsgConfirmation"
            :msgConfirmation="dialogUploadFile.msgConfirmation"
        />

        <ShowFiles 
            :showFiles.sync="dialogShowFiles.show"
            :showAsCarrousel.sync="dialogShowFiles.showAsCarrousel"
            :reload="dialogShowFiles.reload"
            :showFilters="dialogShowFiles.showFilters"
            :listParams="dialogShowFiles.listParams"
        />

        <DialogHomeOwnerResponsability 
            v-on:methodConfirmToCall="dialogHOResp.methodConfirm"
            :showDialogHOResp.sync="dialogHOResp.show"
            :id="dialogHOResp.id"
        />

        <v-dialog
            v-model="showDialogAdditionalInformationContract"
            transition="dialog-top-transition"
            persistent
            width="800"
            :fullscreen="$vuetify.breakpoint.mobile"
        >
            <v-card>
                <v-card-title class="text-h5 lighten-2 formDialog" style="border-bottom: solid 1px var(--color__cinza)">
                    Additional information in the contract
                </v-card-title>

                <v-card-text style="margin-top: 20px;">
                    <v-row>
                        <v-col 
                            cols="12"
                            lg="12"
                            md="12"
                            sm="12"
                        >
                            <label>Notes</label>                            
                            <v-textarea
                                v-model="serviceRequest.additionalInformationContract"
                                single-line
                                rows="10"
                                row-height="130"
                                outlined
                            >
                            </v-textarea>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <div style="width: 100%; text-align: center;">
                        <v-btn
                            class="mx-2 dialogButtonDismiss"
                            style=""
                            outlined
                            @click="showDialogAdditionalInformationContract = false"
                        >
                            Cancel
                        </v-btn>
                        <v-btn
                            class="mx-2"
                            outlined
                            @click="saveAdditionalInfoContract()"
                        >
                            Save
                        </v-btn>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <DialogDocusign 
            v-on:methodConfirmToCall="dialogDocusign.methodConfirm"
            :showDialogDocusign.sync="dialogDocusign.show"
            :idAux="dialogDocusign.idAux"
            :id="dialogDocusign.id"
            :typeDocument="dialogDocusign.typeDocument"
            :customer="dialogDocusign.customer"
        />
    </v-container>
</template>

<script>
    import { mapGetters } from 'vuex';
    import Helpers from '@/utilities/Helpers';
    import { required, requiredFile } from "@/utilities/Rules";
    import zillowTerms from '@/components/Zillow/ZillowTerms';
    import { 
        formaterDecimalBR, 
        formaterDecimalBRServer 
    } from '@/utilities/Utils';
    import ActionDialog from "@/components/Layout/ActionDialog";
    import UploadFile from "@/components/File/UploadFile";
    import ShowFiles from "@/components/File/ShowFiles";
    import JobInformation from "@/components/Services/JobInformation";
    import TechnicalSpecification from "@/components/Services/TechnicalSpecification";
    import DialogHomeOwnerResponsability from "@/components/Services/DialogHomeOwnerResponsability";
    import DialogDocusign from "@/components/Services/DialogDocusign";
    import { 
        TYPE_DOCUMENT, 
        TYPE_ATTACHMENT,
        URL_ATTACHMENT_CONTRACT,
        URL_ATTACHMENT_HOMEOWNER_RESPONSABILITY,
        URL_ATTACHMENT_EXCAVATION_GUIDE,
        TYPE_OF_WORK
    } from "@/utilities/Enums";

    export default ({

        components: {
            zillowTerms,
            ActionDialog,
            UploadFile,
            ShowFiles,
            JobInformation,
            TechnicalSpecification,
            DialogHomeOwnerResponsability,
            DialogDocusign
        },

        mixins: [Helpers],

        props: {
            id: {
                default: 0
            },

            setStep: {
                default: 0
            }
        },

        data: vm => ({

            URL_ATTACHMENT_CONTRACT,
            URL_ATTACHMENT_HOMEOWNER_RESPONSABILITY,
            URL_ATTACHMENT_EXCAVATION_GUIDE,

            steps: 1,

			serviceRequest: {
                id: 0,
                userNameRegister: "",
                customerSelected: {
                    name: ""
                },
                addressSelected: {
                    address: ""
                },
                appointmentCitySelected: {
                    description: "",
                    stateSelected: {
                        code: ""
                    }
                },

            },

            listProjects: [],
            projectSelected: null,
            refreshJob: false,

            listProductSelecteds: [],
            arrayNodeProduct: [],
            searchProduct: "",
            listTreeViewProduct: [],
            listTemplate: [],
            templateSelected: null,

            idServiceItem: 0,
            itemDescription: "",
            itemNote: "",
            itemPrintNote: true,
            itemStyling: "",
            isStylable: false,
            showDialogItemNote: false,

            unitProductFormat: {
                prefix: '',
                suffix: '',
                thousands: '',
                decimal: '.',
                precision: 2,
            },

            moneyFormat: {
                prefix: '$ ',
                suffix: '',
                thousands: ',',
                decimal: '.',
                precision: 2,
            },

            showMoreDetailProducts: false,
            showMoreDetailProductsSW: false,

            grandTotalUpdated: false,
            grandTotalProducts: "$ 0.00",
            selectedTotalProducts: "$ 0.00",
            discount: "0.00",
            grandTotalProductsUnFormatted: 0,
            estimatedValueZillow: "$ 0.00",

            dialog: {
                show: false,
                headerText: "",
                bodyText: "",
                methodConfirm: ( () => {} ),
                methodCancelOrDeny: ( () => {} ),
                params: null
            },

            dialogHOResp: {
                show: false,
                id: 0,
                methodConfirm: ( () => {} )
            },

            dialogUploadFile: {
                show: false,
                idKey: 0,
                reload: 0,
                acceptType: ".pdf",
                typeAttachment: 0,
                typeDocument: 0,
                multipleFiles: false,
                showMsgConfirmation: true,
                msgConfirmation: "",
                methodAfterUpload: ( () => {} ),
            },

            dialogShowFiles: {
                show: false,
                showAsCarrousel: false,
                reload: 0,
                showFilters: false,
                listParams: []
            },

            dialogDocusign: {
                show: false,
                idAux: 0,
                id: 0,
                typeDocument: null,
                customer: null,
                methodConfirm: ( () => {} )
            },

            showDialogAdditionalInformationContract: false,

            showDialogTotalProposal: false,
            showTotalProposal: true,

            statusColorContract: "var(--color__main)",
            statusDescriptionContract: "Completed",

            statusColorScopeOfWork: "var(--color__main)",
            statusDescriptionScopeOfWork: "Completed",

            statusColorHOResp: "var(--color__main)",
            statusDescriptionHOResp: "Completed",

            statusColorExcavationGuide: "var(--color__main)",
            statusDescriptionExcavationGuide: "Completed",

            validFormCustomItem: true,
            showDialogCustomItem: false,
            showDialogCustomItemImages: false,
            listCustomItems: [],
            serviceItemCustomRequest: {
                description: '',
                qty: 1,
                priceFormatted: '$ 0.00',
                price: '$ 0.00',
                total: '$ 0.00',
                note: '',
                optional: 0,
                optionalDescription: 'No'
            },

            customItemFilesPhotos: [],
            customItemPhotos: [],
            itemPhotoToDelete: null,

            validations: {
                file: requiredFile,
                required: required,
                mandatoryProduct (itemProduct) {

                    if ( vm.isProductMandatory(itemProduct) == true && (itemProduct.qty == '0.00' || itemProduct.qty == '' || itemProduct.qty == null))
                        return false
                    else
                        return true
                }
            },
            
            og: Math.pow(10, 2),

            TYPE_DOCUMENT,
            TYPE_OF_WORK
        }),

        computed: {
            ...mapGetters('logInModule', { userLoggedGetters: 'searchState' }),

            proposalCreated() {
                return this.steps == 3 && this.serviceRequest.status == 6
            },

            qtyChannels() {

                let channelQty = 0;
                const listCentralAutomation = this.listProductSelecteds.filter(prd => prd.automationCenter == 1);

                if (listCentralAutomation != null && listCentralAutomation != undefined && listCentralAutomation.length > 0) {

                    listCentralAutomation.forEach(item => {
                        channelQty += item.channelQty;
                    })

                    return channelQty;
                }
                else {
                    return 0;
                }
            },

            automationItemsIsValid() {
                const listAutomatableItems = this.listProductSelecteds.filter(prd => prd.automatable == 1 && prd.notAutomatable == 0);
                let qtyChannelsAvailable = this.qtyChannels;
                let qtyItemsAutomatable = 0;

                listAutomatableItems.forEach(item => {

                    const qty = item.onlyOneChannelConsumed == 1 ? 1 : item.qty;

                    qtyItemsAutomatable += parseInt(qty);
                });

                if (qtyItemsAutomatable > qtyChannelsAvailable) {
                    return false;
                }
                else {
                    return true;
                }
            },

            showCancelButton() {
                return this.steps <= 3
            },

            showBackButton() {
                return this.projectSelected != null && this.projectSelected != undefined && this.projectSelected.status != 7
            },

            showNextButton() {
                return this.steps == 1 || this.steps == 2
            },

            showDownloadAndCreateProposal() {
                return this.steps == 3 && this.serviceRequest.status == 3
            },

            isProjectPool() {
                return this.projectSelected != null && this.projectSelected != undefined && this.projectSelected.pool == 1;
            },

            isProjectBBQ() {
                return this.projectSelected != null && this.projectSelected != undefined && this.projectSelected.bbq == 1;
            },

            isProjectPergola() {
                return this.projectSelected != null && this.projectSelected != undefined && this.projectSelected.pergola == 1;
            },

            isAdminProfile() {
                return this.userLoggedGetters.profile.systemAdmin == 1;
            },
            
            isServiceType() {
                return this.serviceRequest != null && 
                       this.serviceRequest != undefined &&
                       this.serviceRequest.idKindWork != null &&
                       this.serviceRequest.idKindWork != undefined &&
                       this.serviceRequest.idKindWork == this.TYPE_OF_WORK.SERVICE;
            },
            
            isSalesType() {
                return this.serviceRequest != null && 
                       this.serviceRequest != undefined &&
                       this.serviceRequest.idKindWork != null &&
                       this.serviceRequest.idKindWork != undefined &&
                       (this.serviceRequest.idKindWork == this.TYPE_OF_WORK.REMODEL || 
                        this.serviceRequest.idKindWork == this.TYPE_OF_WORK.NEW_PROJECT || 
                        this.serviceRequest.idKindWork == 0);
            },

            hasCustomItems() {
                return this.listCustomItems != null && 
                       this.listCustomItems != undefined && 
                       this.listCustomItems.length > 0;
            },

            grandTotalProductsCustomItems() {
                if (this.listCustomItems != null && this.listCustomItems != undefined && this.listCustomItems.length > 0) {
                    let total = 0;
                    this.listCustomItems.forEach(item => {
                        total += parseFloat(item.total);
                    });
                    return {
                        "unFormatted": total,
                        "formatted": `$ ${formaterDecimalBR(total.toFixed(2))}`
                    }
                }
                else {
                    return { 
                        "unFormatted": 0,
                        "formatted": "$ 0.00"
                    };
                }
            },

            hasAdjustment() {
                return this.serviceRequest != null &&
                        this.serviceRequest != undefined &&
                        this.serviceRequest.adjustment != null && 
                        this.serviceRequest.adjustment != undefined && 
                        this.serviceRequest.adjustment != 0;
            },

            grandTotalSelectedProducts() {
                let total = 0;
                this.listProductSelecteds.filter(prd => prd.automation == false || prd.notAutomatable == 1).forEach(item => {
                    total += parseFloat(formaterDecimalBRServer(item.total));
                });
                return `$ ${formaterDecimalBR(total.toFixed(2))}`;
            },

            grandTotalAutomationControllers() {
                let total = 0;
                this.listProductSelecteds.filter(prd => prd.automationCenter == 1).forEach(item => {
                    total += parseFloat(formaterDecimalBRServer(item.total));
                });
                return `$ ${formaterDecimalBR(total.toFixed(2))}`;
            },

            grandTotalAutomationItems() {
                let total = 0;
                this.listProductSelecteds.filter(prd => prd.automatable == 1 && prd.notAutomatable == 0).forEach(item => {
                    total += parseFloat(formaterDecimalBRServer(item.total));
                });
                return `$ ${formaterDecimalBR(total.toFixed(2))}`;
            },

            grandAllTotal() {
                return this.hasAdjustment == true && this.showMoreDetailProducts == false ? this.serviceRequest.adjustmentFormatted : this.grandTotalProducts
            }
        },

        methods: {
            
            async back() {
                history.go(-1);
            },

            async controlStep (type) {
                if (type === 'next') {

                    const validForm = await this.validateForm(this.steps);
                    
                    if (validForm == true) {
                        this.steps += 1;
                        await this.saveItems();
                        await this.updateStep();
                        this.refreshJob = !this.refreshJob;
                    }
                }
                else if (type === 'back') {
                    switch (this.steps) {
                        case 3: this.steps = 2; break;
                        case 2: this.steps = 1; break;
                        default: this.steps = 1; break;
                    }
                }
            },

            async getIDProject() {

                let idServiceProject = 0;

                if (this.projectSelected != null && this.projectSelected != null) {
                    idServiceProject = this.projectSelected.id;
                }

                return idServiceProject;
            },
            
            async getRegister() {

                if (this.id !== 0) {

                    const response = await this.$store.dispatch("serviceModule/GetById", this.id);

                    this.serviceRequest = response.result;

                    if (this.setStep != 0) {
                        this.steps = this.setStep;
                    }

                    this.discount = this.serviceRequest.discountFormatted;
                    this.grandTotalProducts = this.serviceRequest.grandTotalFormatted;

                    this.getEstimatedValueZillow();
                    this.allDocumentsIsSigned();
                    await this.checkLoadCalculation();
                }
            },

            async checkLoadCalculation() {

                if (this.serviceRequest == null || this.serviceRequest == undefined) {
                    return;
                }

                const STATUS_SALES_CONTRACTED = 7;

                if (this.serviceRequest.status != STATUS_SALES_CONTRACTED) {
                    return;
                }

                const loadCalculationRequired = this.serviceRequest.loadCalculationRequired;

                if (loadCalculationRequired == 0) {
                    return;
                }

                const responseLoadCalculation = await this.$store.dispatch("serviceModule/GetLoadCalculationById", { id: this.id, idAddress: 0 });

                if (responseLoadCalculation.result.id == 0) {
                    this.dialog = {
                        show: true,
                        headerText: 'Load Calculation Required',
                        bodyText: 'The Load Calculation has not been completed for this project. Would you like to go to the Load Calculation screen to fill it in?',
                        methodConfirm: () => {
                            this.$router.push({ name: 'loadCalculation', params: { id: this.id, pathToBack: 'scopeOfWork', pathToBackParamId: this.id } });
                        },
                        methodCancelOrDeny: ( () => {} ),
                        params: null
                    };
                }
            },

            async updateProject(projectSelected, listProjects, checkValidation = false) {

                this.showLoading();

                await this.getRegister();

                this.projectSelected = projectSelected;
                this.listProjects = listProjects;

                if (projectSelected != null && projectSelected != undefined) {

                    this.steps = this.projectSelected.step;

                    if (this.steps <= 3) {
                        await this.validateChangeTypeProject(checkValidation);
                    }

                    this.serviceRequest.adjustment = this.projectSelected.adjustment;
                    this.serviceRequest.adjustmentFormatted = this.projectSelected.adjustmentFormatted;
                }

                this.hideLoading();
            },

            async getLists() {
                this.listTemplate = await this.$store.dispatch("templateModule/List");
            },

            async validateForm(step) {

                if (step == 1) {

                    let qtyChannelsAvailable = this.qtyChannels;
                    let hasAutomationAndHasMoreOneCentral = false;
                    let hasAutomationAndMoreItemsThanCentralChannel = false;

                    if (qtyChannelsAvailable > 0) {
                        let qtyCentral = this.listProductSelecteds.filter(prd => prd.automationCenter == 1);   

                        hasAutomationAndHasMoreOneCentral = qtyCentral.length > 1;

                        if (this.automationItemsIsValid == false) {
                            hasAutomationAndMoreItemsThanCentralChannel = true;
                        }
                    }

                    let stylingValidate = '';

                    this.listProductSelecteds.forEach(prd => {
                        if (prd.stylable == 1 && (prd.styling == null || prd.styling == undefined || prd.styling.toString().trim() == '')) {
                            stylingValidate = `You must inform the styling of the product [${prd.productDescription}]`
                        }
                    })

                    if (this.projectSelected == null || this.projectSelected == undefined) {
                        this.showToast("error", "Error!", "No project selected.");
                        return false;
                    }
                    else if (this.listProductSelecteds.length == 0 ) {
                        this.showToast("error", "Error!", "No products selected. You must select at least one.");
                        return false;
                    }
                    else if (hasAutomationAndHasMoreOneCentral == true) {
                        this.showToast("error", "Error!", "Only one automation center can be selected.");
                        return false;
                    }
                    else if (hasAutomationAndMoreItemsThanCentralChannel == true) {
                        this.showToast("error", "Error!", "Number of automation items is greater than the number of central channels.");
                        return false;
                    }
                    else if (stylingValidate != '') {
                        this.showToast("error", "Error!", stylingValidate);
                        return false;
                    }
                    else if (await this.checkCategoryAndSubCategoryMandatory() == false) {
                        return false;
                    }
                    else if (await this.checkMandatory()) {
                        return true;
                    }
                }
                else if (step == 2) {

                    return true;
                }
                else {
                    return true;
                }
            },

            async validateChangeTypeProject(checkValidation = false) {

                if (this.listProductSelecteds.length > 0 && checkValidation == true) {
                    this.dialog = {
                        show: true,
                        headerText: 'Confirmation',
                        bodyText: `The scope of work will be lost, would you like to create a template?`,
                        methodConfirm: this.createTemplate,
                        methodCancelOrDeny: this.updateTreeViewProduct,
                        params: 0
                    };
                }
                else {
                    await this.getCustomItems();
                    await this.updateTreeViewProduct();
                }
            },

            async createTemplate() {

                this.showLoading();

                let customerName = '';
                let typeOfWork = '';
                let typeOfProject = '';
                
                if (this.serviceRequest.customerSelected != null && this.serviceRequest.customerSelected != undefined) {
                    customerName = this.serviceRequest.customerSelected.fullName;
                }
                
                if (this.projectSelected.typeWorkSelected != null && this.projectSelected.typeWorkSelected != undefined) {
                    typeOfWork = this.projectSelected.typeWorkSelected.kindWorkDescription;
                }

                if (this.isProjectPool) {
                    typeOfProject = ' - Pool'
                }
                else if (this.isProjectBBQ) {
                    typeOfProject = ' - BBQ'
                }
                else if (this.isProjectPergola) {
                    typeOfProject = ' - Outdoor'
                }

                const today = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);

                let listItemRequest = [];

                this.listProductSelecteds.forEach(itemProduct => {

                    listItemRequest.push({
                        id: itemProduct.id,
                        idProduct: itemProduct.idProduct,
                        qty: itemProduct.qty
                    });
                })

                const templateName = `${customerName} - ${typeOfWork}${typeOfProject} - ${this.formatDate(today)}`
                const templateRequest = {
                    status: 1,
                    public: 0,
                    name: templateName,
                    listItemRequest: listItemRequest
                }

                const result = await this.$store.dispatch("templateModule/CreateUpdate", templateRequest);

                if (result.success === true) {
                    this.showToast("success", "Success!", `Template [${templateName}] created successfully.`);
                    this.deleteAllItems();
                }
                else {
                    this.showToast("error", "Warning!", result.message);
                }

                this.hideLoading();
            },

            async updateTreeViewProduct() {
                const idServiceProject = await this.getIDProject();

                const request = { 
                    id: idServiceProject, 
                    type: 'SERVICE',
                    showOnlyCreatedItems: false, 
                    fromHistory: false 
                };

                this.listTreeViewProduct = await this.$store.dispatch("productModule/ListProductsToScopeOfWork", request);

                await this.updateItemsProduct();
            },

            async updateItemsProduct() {

                const idServiceProject = await this.getIDProject();

                if (idServiceProject != 0) {
                
                    this.listProductSelecteds = [];
                    let grandTotal = 0;
                    this.listTreeViewProduct.forEach(itemCategory => {
                        itemCategory.children.forEach(itemSubCategoryOrProduct => {
                            
                            if (itemSubCategoryOrProduct.type == 'SubCategory') {

                                itemSubCategoryOrProduct.children.forEach(itemProduct => {

                                    if (itemProduct.qty != null && itemProduct.qty != undefined && itemProduct.qty != "0.00" && itemProduct.qty != "" ) {

                                        let qty = parseFloat(itemProduct.qty == '' ? 0 : itemProduct.qty);
                                        
                                        if (qty <= 0) {
                                            this.showToast("error", "Warning!", "Quantity cannot be negative!");
                                            itemProduct.qty = '';
                                        }
                                        else {

                                            let total = (qty * itemProduct.price).toFixed(2);

                                            this.listProductSelecteds.push({
                                                id: itemProduct.idServiceItem,
                                                idService: idServiceProject,
                                                idCategory: itemCategory.id,
                                                categoryDescription: itemCategory.name,
                                                idSubCategory: itemSubCategoryOrProduct.id,
                                                subCategoryDescription: itemSubCategoryOrProduct.name,
                                                productDescription: itemProduct.name,
                                                productDetails: itemProduct.details,
                                                idProduct: itemProduct.idTable,
                                                qty: itemProduct.qty,
                                                automation: itemProduct.automatable == 1 || itemProduct.automationCenter == 1,
                                                automatable: itemProduct.automatable,
                                                automationCenter: itemProduct.automationCenter,
                                                channelQty: itemProduct.channelQty,
                                                onlyOneChannelConsumed: itemProduct.onlyOneChannelConsumed,
                                                highlight: itemProduct.highlight,
                                                highlightDescription: itemProduct.highlightDescription,
                                                unitySymbol: itemProduct.unitySymbol,
                                                price: formaterDecimalBR(itemProduct.price),
                                                total: formaterDecimalBR(total),
                                                note: itemProduct.note,
                                                styling: itemProduct.styling,
                                                customOrder: itemProduct.customOrder,
                                                stylable: itemProduct.stylable,
                                                optional: itemProduct.optional,
                                                notAutomatable: itemProduct.notAutomatable,
                                                printNote: itemProduct.printNote,
                                                requiredAtLeastOneProductCategory: itemProduct.requiredAtLeastOneProductCategory,
                                                requiredAtLeastOneProductSubCategory: itemProduct.requiredAtLeastOneProductSubCategory,
                                                requiredOnlyOneProductCategory: itemProduct.requiredOnlyOneProductCategory,
                                                requiredOnlyOneProductSubCategory: itemProduct.requiredOnlyOneProductSubCategory
                                            })

                                            grandTotal += parseFloat(total);
                                        }
                                    }
                                    else {
                                        itemProduct.qty = '';
                                    }
                                });
                            }
                            else {
                                
                                if (itemSubCategoryOrProduct.qty != null && itemSubCategoryOrProduct.qty != undefined && itemSubCategoryOrProduct.qty != "0.00" && itemSubCategoryOrProduct.qty != "" ) {

                                    let qty = parseFloat(itemSubCategoryOrProduct.qty == '' ? 0 : itemSubCategoryOrProduct.qty);

                                    if (qty <= 0) {
                                        this.showToast("error", "Warning!", "Quantity cannot be negative!");
                                        itemSubCategoryOrProduct.qty = ''
                                    }
                                    else {
                                        
                                        let total = (qty * itemSubCategoryOrProduct.price).toFixed(2);

                                        this.listProductSelecteds.push({
                                            id: itemSubCategoryOrProduct.idServiceItem,
                                            idService: idServiceProject,
                                            idCategory: itemCategory.id,
                                            categoryDescription: itemCategory.name,
                                            idSubCategory: 0,
                                            subCategoryDescription: "",
                                            productDescription: itemSubCategoryOrProduct.name,
                                            productDetails: itemSubCategoryOrProduct.details,
                                            idProduct: itemSubCategoryOrProduct.idTable,
                                            qty: itemSubCategoryOrProduct.qty,
                                            automation: itemSubCategoryOrProduct.automatable == 1 || itemSubCategoryOrProduct.automationCenter == 1,
                                            automatable: itemSubCategoryOrProduct.automatable,
                                            automationCenter: itemSubCategoryOrProduct.automationCenter,
                                            channelQty: itemSubCategoryOrProduct.channelQty,
                                            onlyOneChannelConsumed: itemSubCategoryOrProduct.onlyOneChannelConsumed,
                                            highlight: itemSubCategoryOrProduct.highlight,
                                            highlightDescription: itemSubCategoryOrProduct.highlightDescription,
                                            unitySymbol: itemSubCategoryOrProduct.unitySymbol,
                                            price: formaterDecimalBR(itemSubCategoryOrProduct.price),
                                            total: formaterDecimalBR(total),
                                            note: itemSubCategoryOrProduct.note,
                                            styling: itemSubCategoryOrProduct.styling,
                                            customOrder: itemSubCategoryOrProduct.customOrder,
                                            stylable: itemSubCategoryOrProduct.stylable,
                                            optional: itemSubCategoryOrProduct.optional,
                                            notAutomatable: itemSubCategoryOrProduct.notAutomatable,
                                            printNote: itemSubCategoryOrProduct.printNote,
                                            requiredAtLeastOneProductCategory: itemSubCategoryOrProduct.requiredAtLeastOneProductCategory,
                                            requiredAtLeastOneProductSubCategory: itemSubCategoryOrProduct.requiredAtLeastOneProductSubCategory,
                                            requiredOnlyOneProductCategory: itemSubCategoryOrProduct.requiredOnlyOneProductCategory,
                                            requiredOnlyOneProductSubCategory: itemSubCategoryOrProduct.requiredOnlyOneProductSubCategory
                                        })
                                        grandTotal += parseFloat(total);
                                    }
                                }
                                else {
                                    itemSubCategoryOrProduct.qty = ''
                                }
                            }                            

                            this.$forceUpdate();
                        });
                    });
                    
                    const selectedItemsTotal = grandTotal;

                    if (this.hasCustomItems == true) {
                        grandTotal += this.grandTotalProductsCustomItems.unFormatted;
                    }

                    this.grandTotalProductsUnFormatted = grandTotal;

                    const discount = formaterDecimalBRServer(this.serviceRequest.discount);
                    if (discount > 0) {
                        grandTotal -= discount;
                    }
                    
                    this.permitFee = formaterDecimalBR(this.serviceRequest.permitFee);

                    if (this.permitFee > 0) {
                        const permitFeeValue = Math.floor(grandTotal * (this.permitFee / 100));
                        grandTotal += permitFeeValue;
                    }

                    if (this.grandTotalUpdated == false) {
                        this.selectedTotalProducts = `$ ${formaterDecimalBR(((selectedItemsTotal * this.og) / this.og).toFixed())}`;
                        this.grandTotalProducts = `$ ${formaterDecimalBR(((grandTotal * this.og) / this.og).toFixed())}`;
                    }
                }
            },

            async getEstimatedValueZillow() {

                let zillowRequest = {
                    typeRequest: 2, //Address
                    zipCodeOrAddress: "",
                }

                if (this.serviceRequest.addressSelected != null && this.serviceRequest.addressSelected != undefined) {
                    zillowRequest.zipCodeOrAddress = this.serviceRequest.addressSelected.address;
                    this.address = this.serviceRequest.addressSelected.address;
                }

                let response = await this.$vanKirkApi.post(`common/zillow`, zillowRequest, {
                        headers: {
                            "content-type": "application/json"
                        }
                    });
                let resultZillow = response.data.result;

                this.estimatedValueZillow = "$ 0,00";
                    
                if (resultZillow && resultZillow.success == true && resultZillow.bundle.length > 0) {
                    this.estimatedValueZillow = resultZillow.bundle[0].zEstimateFormatted;
                }
                else {
                    this.estimatedValueZillow = "Not found"
                }
            },

            async confirmationApplyTemplate() {

                this.dialog = {
                    show: true,
                    headerText: 'Confirmation',
                    bodyText: 'Do you want to APPLY the selected Template, overwriting the current SCOPE OF WORK?',
                    methodConfirm: this.applyTemplate,
                    params: 0
                };

            },

            async applyTemplate() {
                this.listTreeViewProduct = await this.$store.dispatch("productModule/ListProductsToScopeOfWork", { id: 0, type: 'SERVICE', showOnlyCreatedItems: false, fromHistory: false });
                let response = await this.$store.dispatch("templateModule/GetById", this.templateSelected.id);

                let listTemplateItem = response.result.listItemResponse;

                this.listTreeViewProduct.forEach(itemCategory => {
                    itemCategory.children.forEach(itemSubCategoryOrProduct => {
                        
                        if (itemSubCategoryOrProduct.type == 'SubCategory') {

                            itemSubCategoryOrProduct.children.forEach(itemProduct => {

                                let itemTemplate = listTemplateItem.filter(tpi => tpi.idProduct == itemProduct.idTable)[0];
                                if (itemTemplate != null && itemTemplate != undefined) {
                                    itemProduct.qty = itemTemplate.qty.toString();
                                }
                            });
                        }
                        else {
                            
                            let itemTemplate = listTemplateItem.filter(tpi => tpi.idProduct == itemSubCategoryOrProduct.idTable)[0];
                            if (itemTemplate != null && itemTemplate != undefined) {
                                itemSubCategoryOrProduct.qty = itemTemplate.qty.toString();
                            }
                        }
                    });
                });

                this.updateItemsProduct();
            },

            focusInput(item) {
                this.arrayNodeProduct = []
                this.arrayNodeProduct.push(item.idCategory);
                if (item.idSubCategory != null && item.idSubCategory != undefined && item.idSubCategory != 0)  {
                    this.arrayNodeProduct.push(item.idSubCategory);
                }

                setTimeout(() => {
                    let txtComponent = document.getElementById(`productQty${item.idProduct}`);
                    txtComponent.focus();
                }, 100);

            },

            onOpenTreeViewProduct(items) {
                this.arrayNodeProduct = items
            },

            async cancel() {
                if (this.isServiceType == false) {
                    this.$router.push({ path: "/sales/pipeline" });
                }
                else {
                    this.$router.push({ path: "/service/salesPipeline" });
                }
            },

            async saveItems(silent = false) {

                const idServiceProject = await this.getIDProject();

                const request = {
                    id: idServiceProject,
                    notesScopeOfWork: this.projectSelected?.notesScopeOfWork
                }

                const resultService = await this.$store.dispatch("serviceModule/UpdateNoteScopeOfWork", request);

                if (resultService.success === true) {

                    let listProducts = [];

                    const grandTotalProducts = formaterDecimalBRServer(this.selectedTotalProducts);

                    let discount = 0;

                    if (this.discount != null && this.discount != undefined) {
                        discount = formaterDecimalBRServer(this.discount);
                    }

                    const adjustment = formaterDecimalBRServer(this.serviceRequest.adjustmentFormatted);

                    this.listProductSelecteds.forEach (item => {
                        listProducts.push({
                            id: item.id,
                            idServiceProject,
                            idProduct: item.idProduct,
                            idBolws: 0,
                            qty: item.qty,
                            newQty: item.qty,
                            price: item.price,
                            notes: item.notes,
                            discount,
                            adjustment,
                            grandTotal: grandTotalProducts
                        })
                    })

                    if (listProducts.length <= 0) {
                        listProducts.push({
                            id: 0,
                            idServiceProject,
                            qty: '0',
                            newQty: '0',
                            idProduct: 0,
                            price: '0',
                            discount: 0,
                            adjustment: 0,
                            grandTotal: 0
                        })
                    }

                    const result = await this.$store.dispatch("serviceModule/CreateUpdateItems", { serviceItemRequest: listProducts, createHistory: false, oficial: 0, uploadAddendum: 0 });

                    if (silent == false) {
                        if (result.success === true) {
                            this.showToast("success", "Success!", result.message);
                            return true;
                        }
                        else {
                            this.showToast("error", "Warning!", result.message);
                            return false;
                        }
                    }

                    await this.updateTreeViewProduct();
                }
                else {
                    if (silent == false) {
                        this.showToast("error", "Warning!", resultService.message);
                        return false;
                    }
                }
            },

            async updateStep() {

                let idServiceProject = await this.getIDProject();

                const result = await this.$store.dispatch("serviceModule/UpdateStep", { id: idServiceProject, newStep: this.steps} );

                if (result.success === false) {
                    this.showToast("error", "Warning!", result.message);
                }
            },

            async confirmCreateProposal() {

                let projectNotOK = "";
                let projectAndVersion = "";

                this.listProjects.forEach(itemProject => {

                    if (itemProject.step < 3) {
                        projectNotOK += `- ${itemProject.name} <br />`
                    }

                    projectAndVersion += `${itemProject.name} - [${itemProject.versionName}] <br />`
                });

                if (projectNotOK != "") {
                    // projectNotOK = projectNotOK.substring(0, projectNotOK.length - 2) + "]";
                    this.showToast("error", "Warning!", `You must complete all steps about projects below: <br /><br /> ${projectNotOK}`);
                }
                else {
                    this.dialog = {
                        show: true,
                        headerText: 'Confirmation',
                        bodyText: `Would like to create a new PROPOSAL about the projects/version below? <br /><br /> ${projectAndVersion}`,
                        methodConfirm: this.createProposal,
                        params: 0
                    };
                }
            },

            async createProposal() {
                
                this.showLoading();

                let updateStatusRequest = {
                    id: this.id,
                    status: 5 //Waiting Approval
                };

                let result = await this.$store.dispatch("serviceModule/UpdateStatus", updateStatusRequest);

                if (result.success) {
                    this.showToast("success", "Success!", "Proposal created successfully");
                }
                else {
                    this.showToast("error", "Error!", result.message);
                }

                this.cancel();

                this.hideLoading();
            },

            async deleteItem(item) {
                
                this.listTreeViewProduct.forEach(itemCategory => {
                    itemCategory.children.forEach(itemSubCategoryOrProduct => {
                        
                        if (itemSubCategoryOrProduct.type == 'SubCategory') {

                            itemSubCategoryOrProduct.children.forEach(itemProduct => {

                                if (itemProduct.idTable == item.idProduct) {
                                    itemProduct.qty = ''
                                }
                            });
                        }
                        else {
                            if (itemSubCategoryOrProduct.idTable == item.idProduct) {
                                itemSubCategoryOrProduct.qty = ''
                            }
                        }
                    });
                });

                await this.updateItemsProduct();
                await this.saveItems(true);
            },

            async deleteAllItems() {
                
                this.listTreeViewProduct.forEach(itemCategory => {
                    itemCategory.children.forEach(itemSubCategoryOrProduct => {
                        
                        if (itemSubCategoryOrProduct.type == 'SubCategory') {

                            itemSubCategoryOrProduct.children.forEach(itemProduct => {
                                itemProduct.qty = ''
                            });
                        }
                        else {
                            itemSubCategoryOrProduct.qty = ''
                        }
                    });
                });

                await this.saveItems(true);
                await this.updateItemsProduct();
            },

            uploadSignedExcavationGuide() {
                this.dialogUploadFile = {
                    show: true,
                    idKey: this.id,
                    reload: Math.random(),
                    acceptType: ".pdf",
                    typeAttachment: TYPE_ATTACHMENT.SERVICE.value,
                    typeDocument: TYPE_DOCUMENT.EXCAVATION_GUIDE.value,
                    multipleFiles: false,
                    showMsgConfirmation: true,
                    msgConfirmation: "You are about to upload the signed excavation guide to the system, confirm this decision?",
                    methodAfterUpload: this.checkAllDocumentsSigned,
                };
            },

            uploadSignedContract() {
                this.dialogUploadFile = {
                    show: true,
                    idKey: this.id,
                    reload: Math.random(),
                    acceptType: ".pdf",
                    typeAttachment: TYPE_ATTACHMENT.SERVICE.value,
                    typeDocument: TYPE_DOCUMENT.CONTRACT.value,
                    multipleFiles: false,
                    showMsgConfirmation: true,
                    msgConfirmation: "You are about to upload the signed contract to the system, confirm this decision?",
                    methodAfterUpload: this.checkAllDocumentsSigned,
                };
            },

            uploadSignedScopeOfWork() {
                this.dialogUploadFile = {
                    show: true,
                    idKey: this.id,
                    reload: Math.random(),
                    acceptType: ".pdf",
                    typeAttachment: TYPE_ATTACHMENT.SERVICE.value,
                    typeDocument: TYPE_DOCUMENT.PROPOSAL.value,
                    multipleFiles: false,
                    showMsgConfirmation: true,
                    msgConfirmation: "You are about to upload the signed scope of work to the system, confirm this decision?",
                    methodAfterUpload: this.checkAllDocumentsSigned,
                };
            },

            uploadSignedHomeownerResponsability() {
                this.dialogUploadFile = {
                    show: true,
                    idKey: this.id,
                    reload: Math.random(),
                    acceptType: ".pdf",
                    typeAttachment: TYPE_ATTACHMENT.SERVICE.value,
                    typeDocument: TYPE_DOCUMENT.HOMEOWNER_RESPONSABILITY.value,
                    multipleFiles: false,
                    showMsgConfirmation: true,
                    msgConfirmation: "You are about to upload the signed homeowner responsability to the system, confirm this decision?",
                    methodAfterUpload: this.checkAllDocumentsSigned,
                };
            },

            async allDocumentsIsSigned() {

                this.showLoading();

                const listAttachments = await this.$store.dispatch("attachmentModule/GetAll", { typeAttachment: TYPE_ATTACHMENT.SERVICE.value, idKey: this.id });

                const contractUploaded = listAttachments.filter(item => item.typeDocument == TYPE_DOCUMENT.CONTRACT.value)[0];
                const scopeOfWorkUploaded = listAttachments.filter(item => item.typeDocument == TYPE_DOCUMENT.PROPOSAL.value)[0];
                const hoRespUploaded = listAttachments.filter(item => item.typeDocument == TYPE_DOCUMENT.HOMEOWNER_RESPONSABILITY.value)[0];
                const excavationGuideUploaded = listAttachments.filter(item => item.typeDocument == TYPE_DOCUMENT.EXCAVATION_GUIDE.value)[0];

                const statusCompletedColor = "var(--color__main)";
                const statusCompletedDescription = "Completed";
                const statusPendingColor = "var(--color__alert)";
                const statusPendingDescription = "Pending";

                if (contractUploaded == null || contractUploaded == undefined) {
                    this.statusColorContract = statusPendingColor;
                    this.statusDescriptionContract = statusPendingDescription;
                }
                else {
                    this.statusColorContract = statusCompletedColor;
                    this.statusDescriptionContract = statusCompletedDescription;
                }

                if (scopeOfWorkUploaded == null || scopeOfWorkUploaded == undefined) {
                    this.statusColorScopeOfWork = statusPendingColor;
                    this.statusDescriptionScopeOfWork = statusPendingDescription;
                }
                else {
                    this.statusColorScopeOfWork = statusCompletedColor;
                    this.statusDescriptionScopeOfWork = statusCompletedDescription;
                }

                if (hoRespUploaded == null || hoRespUploaded == undefined) {
                    this.statusColorHOResp = statusPendingColor;
                    this.statusDescriptionHOResp = statusPendingDescription;
                }
                else {
                    this.statusColorHOResp = statusCompletedColor;
                    this.statusDescriptionHOResp = statusCompletedDescription;
                }

                if (excavationGuideUploaded == null || excavationGuideUploaded == undefined) {
                    this.statusColorExcavationGuide = statusPendingColor;
                    this.statusDescriptionExcavationGuide = statusPendingDescription;
                }
                else {
                    this.statusColorExcavationGuide = statusCompletedColor;
                    this.statusDescriptionExcavationGuide = statusCompletedDescription;
                }

                this.$forceUpdate();
                this.hideLoading();

                if (this.isServiceType == true) {
                    return contractUploaded != null && contractUploaded != undefined &&
                        scopeOfWorkUploaded != null && scopeOfWorkUploaded != undefined &&
                        excavationGuideUploaded != null && excavationGuideUploaded != undefined;

                }
                else {
                    return contractUploaded != null && contractUploaded != undefined &&
                        scopeOfWorkUploaded != null && scopeOfWorkUploaded != undefined &&
                        hoRespUploaded != null && hoRespUploaded != undefined &&
                        excavationGuideUploaded != null && excavationGuideUploaded != undefined;                    
                }
            },

            async checkAllDocumentsSigned() {
                if (await this.allDocumentsIsSigned()) {
                
                    this.dialog = {
                        show: true,
                        headerText: 'Confirmation',
                        bodyText: 'You are about to upload all documents to the system, and, from this moment on, only an administrator will be able to edit this job, do you confirm this decision?',
                        methodConfirm: this.uploadProposalSuccess,
                        params: 0
                    };
                }
            },

            async uploadProposalSuccess() {
                
                this.showLoading();

                const updateStatusRequest = {
                    id: this.id,
                    status: 7 //Contracted
                };

                const result = await this.$store.dispatch("serviceModule/UpdateStatus", updateStatusRequest);

                if (result.success) {
                    this.showToast("success", "Success!", "Proposal uploaded successfully");
                    
                    if (this.isServiceType == false && this.serviceRequest.techSpecIsRequired == 1) {
                        await this.getRegister();
                        this.refreshJob = !this.refreshJob;
                        this.steps = 4;
                    }
                    else {

                        if (this.serviceRequest.techSpecIsRequired == 0) {
                            this.listProjects.forEach(itemProject => {
                                const updateStatusRequest = {
                                    id: itemProject.id,
                                    status: 8 //Drafting - Check List
                                };

                                this.$store.dispatch("serviceModule/UpdateProjectStatus", updateStatusRequest);
                            })
                        }

                        this.cancel();
                    }
                }
                else {
                    this.showToast("error", "Error!", result.message);
                }

                this.hideLoading();
            },

            async downloadProposal() {

                this.showLoading();

                if (this.showTotalProposal == null || this.showTotalProposal == undefined || this.showTotalProposal == 0) {
                    this.showTotalProposal = false;
                }

                this.$vanKirkApi.get(`service/download-proposal/${this.id}/0/false/${this.showTotalProposal}/false`, {
                        responseType: "blob",
                    })
                    .then((response) => {

                        var blob = new Blob([response.data], {
                            type: "application/pdf",
                        });

                        var url = window.URL.createObjectURL(blob);
                        window.open(url);

                        this.hideLoading();
                    })
                    .catch(error => {
                        
                        let errorMessage = "";
                        if (error.response && error.response.status === 400) {
                            errorMessage = `Error to generate proposal: [${error.response.data}]`;
                        }
                        else {
                            errorMessage = `Error to generate proposal: [${error}]`;
                        }
                        
                        this.showToast("error", "Erro!", errorMessage);
                        this.hideLoading();
                    }
                );
            },

            async checkCategoryAndSubCategoryMandatory() {

                let listCategoryAndSubCategoryAtLeastOne = [];
                let listCategoryAndSubCategoryOnlyOne = [];

                this.listTreeViewProduct.forEach(itemCategory => {
                    itemCategory.children.forEach(itemSubCategoryOrProduct => {
                        
                        if (itemSubCategoryOrProduct.type == 'SubCategory' && itemSubCategoryOrProduct.requiredAtLeastOneProductSubCategory == 1) {

                            itemSubCategoryOrProduct.children.forEach(itemProduct => {

                                const productEmpty = itemProduct.qty == '0.00' || itemProduct.qty == '' || itemProduct.qty == null;
                                const productEmptyQty = itemSubCategoryOrProduct.children.filter(item => item.qty == '0.00' || item.qty == '' || item.qty == null).length;

                                if (productEmpty == true && productEmptyQty == itemSubCategoryOrProduct.children.length) {

                                    const existsItem = listCategoryAndSubCategoryAtLeastOne.filter(item => item.name == itemSubCategoryOrProduct.name)[0];

                                    if (existsItem == null || existsItem == undefined) {
                                        listCategoryAndSubCategoryAtLeastOne.push({
                                            name: itemSubCategoryOrProduct.name,
                                            message: ` - <strong>SubCategory:</strong> ${itemSubCategoryOrProduct.name}<br />`
                                        });
                                    }
                                }
                            });
                        }
                        else if (itemCategory.requiredAtLeastOneProductCategory == 1) {
                            const productEmpty = itemSubCategoryOrProduct.qty == '0.00' || itemSubCategoryOrProduct.qty == '' || itemSubCategoryOrProduct.qty == null;
                            const productEmptyQty = itemCategory.children.filter(item => item.qty == '0.00' || item.qty == '' || item.qty == null).length;

                            if (productEmpty == true && productEmptyQty == itemCategory.children.length) {

                                const existsItem = listCategoryAndSubCategoryAtLeastOne.filter(item => item.name == itemCategory.name)[0];

                                if (existsItem == null || existsItem == undefined) {
                                    listCategoryAndSubCategoryAtLeastOne.push({
                                        name: itemCategory.name,
                                        message: ` - <strong>Category:</strong> ${itemCategory.name}<br />`
                                    });
                                }
                            }
                        }
                        
                        //Only one é required
                        if (itemSubCategoryOrProduct.type == 'SubCategory' && itemSubCategoryOrProduct.requiredOnlyOneProductSubCategory == 1) {

                            itemSubCategoryOrProduct.children.forEach(itemProduct => {

                                const productNotEmptyQty = itemProduct.children.filter(item => item.qty != '0.00' && item.qty != '' && item.qty != null).length;

                                if (productNotEmptyQty != 1) {

                                    const existsItem = listCategoryAndSubCategoryOnlyOne.filter(item => item.name == itemSubCategoryOrProduct.name)[0];

                                    if (existsItem == null || existsItem == undefined) {
                                        listCategoryAndSubCategoryOnlyOne.push({
                                            name: itemSubCategoryOrProduct.name,
                                            message: ` - <strong>SubCategory:</strong> ${itemSubCategoryOrProduct.name}<br />`
                                        });
                                    }
                                }
                            });
                        }
                        else if (itemCategory.requiredOnlyOneProductCategory == 1) {

                            const productNotEmptyQty = itemCategory.children.filter(item => item.qty != '0.00' && item.qty != '' && item.qty != null).length;

                            if (productNotEmptyQty != 1) {

                                const existsItem = listCategoryAndSubCategoryOnlyOne.filter(item => item.name == itemCategory.name)[0];

                                if (existsItem == null || existsItem == undefined) {
                                    listCategoryAndSubCategoryOnlyOne.push({
                                        name: itemCategory.name,
                                        message: ` - <strong>Category:</strong> ${itemCategory.name}<br />`
                                    });
                                }
                            }
                        }
                    });
                });

                if (listCategoryAndSubCategoryAtLeastOne.length > 0) {
                    let listItensMessage = '';
                    listCategoryAndSubCategoryAtLeastOne.forEach(item => {
                        listItensMessage += item.message
                    });
                    this.showToast("error", "Error!", `You must choose at least one product from the category or sub-category below: <br /> <br /> ${listItensMessage}`);
                }

                if (listCategoryAndSubCategoryOnlyOne.length > 0) {
                    let listItensMessage = '';
                    listCategoryAndSubCategoryOnlyOne.forEach(item => {
                        listItensMessage += item.message
                    });
                    this.showToast("error", "Error!", `You must choose only one product from the category or sub-category below: <br /> <br /> ${listItensMessage}`);
                }

                return listCategoryAndSubCategoryAtLeastOne.length <= 0 && listCategoryAndSubCategoryOnlyOne.length <= 0;
            },

            async checkMandatory() {

                let allFieldsOK = true;
                let listProductName = ''

                this.listTreeViewProduct.forEach(itemCategory => {
                    itemCategory.children.forEach(itemSubCategoryOrProduct => {
                        
                        if (itemSubCategoryOrProduct.type == 'SubCategory') {

                            itemSubCategoryOrProduct.children.forEach(itemProduct => {

                                allFieldsOK = this.validations.mandatoryProduct(itemProduct);

                                if (allFieldsOK == false) {
                                    listProductName += ` - ${itemProduct.name}<br />`;
                                }
                            });
                        }
                        else {
                            allFieldsOK = this.validations.mandatoryProduct(itemSubCategoryOrProduct);

                            if (allFieldsOK == false) {
                                listProductName += ` - ${itemSubCategoryOrProduct.name}<br />`;
                            }
                        }
                    });
                });

                if (listProductName != '') {
                    this.showToast("error", "Error!", `The items below are mandatory: <br /> <br /> ${listProductName}`);
                }

                return listProductName == '';
            },

            isProductMandatory(itemProduct) {

                return (itemProduct.mandatoryPool == 1    && this.isProjectPool == true) ||
                       (itemProduct.mandatoryBBQ == 1     && this.isProjectBBQ == true)  ||
                       (itemProduct.mandatoryPergola == 1 && this.isProjectPergola == true)
            },

            isCategoryOrSubCategoryMandatory(itemProduct) {

                const categoryIsMandatory = itemProduct.type == 'Category' && itemProduct.requiredAtLeastOneProductCategory == 1;
                const subCategoryIsMandatory = itemProduct.type == 'SubCategory' && itemProduct.requiredAtLeastOneProductSubCategory == 1;

                return (categoryIsMandatory == true) ||
                       (subCategoryIsMandatory == true)
            },

            async showItemNote(item, type) {

                if (item.id == null || item.id == undefined || item.id == 0) {
                    await this.saveItems(true);
                }

                item = this.listProductSelecteds.filter(prs => prs.idProduct == item.idProduct)[0];

                this.idServiceItem = item.id;

                if (type == 'BOWL') {
                    this.itemDescription = item.bowlDescription;
                }
                else {
                    this.itemDescription = item.productDescription;
                }
                this.itemNote = item.note;
                this.itemPrintNote = item.printNote == 1;
                this.itemStyling = item.styling;
                this.isStylable = item.stylable == 1;
                this.showDialogItemNote = true;
            },

            async saveItemNote() {

                const serviceItemNoteRequest = {
                    id: this.idServiceItem,
                    notes: this.itemNote,
                    printNote: this.itemPrintNote ? 1 : 0,
                    styling: this.itemStyling
                }
                
                const result = await this.$store.dispatch("serviceModule/UpdateItemNote", serviceItemNoteRequest);

                if (result.success === true) {
                    this.showToast("success", "Success!", result.message);
                    await this.updateTreeViewProduct();
                    this.showDialogItemNote = false;
                }
                else {
                    this.showToast("error", "Warning!", result.message);
                    return false;
                }
            },

            async showProductsImages(itemProduct) {

                let listParams = [];
                listParams.push({
                    typeAttachment: TYPE_ATTACHMENT.PRODUCT.value,
                    typeDocument: TYPE_DOCUMENT.PRODUCT.value,
                    idKey: itemProduct.idProduct,
                    isImage: true
                })

                this.dialogShowFiles = {
                    show: true,
                    showAsCarrousel: false,
                    reload: Math.random(),
                    showFilters: false,
                    listParams
                };
            },

            async showProductsDocs(itemProduct) {

                let listParams = [];
                listParams.push({
                    typeAttachment: TYPE_ATTACHMENT.PRODUCT.value,
                    typeDocument: TYPE_DOCUMENT.PRODUCT_DOCS.value,
                    idKey: itemProduct.idProduct,
                    isImageAndDoc: true
                })

                this.dialogShowFiles = {
                    show: true,
                    reload: Math.random(),
                    showFilters: false,
                    listParams
                };
            },

            async checkDiscount(discountValue) {
                const discountSalesPerson = this.userLoggedGetters.discount;

                if (this.isAdminProfile == false && discountValue > 0 && discountValue > discountSalesPerson) {
                    this.showToast('error', 'Warning', `Discount above the permitted ${this.userLoggedGetters.discountFormatted}`);
                    this.discount = '0.00';
                    this.grandTotalProducts = `$ ${formaterDecimalBR(Math.round(Math.floor(this.grandTotalProductsUnFormatted * this.og) / this.og))}`;
                    this.grandTotalUpdated = false;
                    return false;
                }
                
                return true;
            },

            async calculateTotal(type) {

                const discountUnformatted = formaterDecimalBRServer(this.discount);

                if (type == 'd') { //discount
                    if (await this.checkDiscount(discountUnformatted) == true) {
                        const newValue = this.grandTotalProductsUnFormatted - discountUnformatted;
                        this.grandTotalProducts = `$ ${formaterDecimalBR(Math.round(Math.floor(newValue * this.og) / this.og))}`;
                    }
                }
            },

            async updateOptional(item) {

                let optional = 0;

                if (item.optional != null && item.optional != undefined) {
                    optional = item.optional == true ? 1 : 0;
                }

                if (item.id == null || item.id == undefined || item.id == 0) {
                    await this.saveItems(true);
                }

                item = this.listProductSelecteds.filter(prs => prs.idProduct == item.idProduct)[0];

                const idItem = item.idItem || item.id;
                const serviceItemOptionalRequest = {
                    id: idItem,
                    idItem,
                    type: "SI",
                    optional
                }
                
                const result = await this.$store.dispatch("serviceModule/UpdateItemOptional", serviceItemOptionalRequest);

                if (result.success === true) {
                    this.showToast("success", "Success!", result.message);
                    await this.updateTreeViewProduct();
                    this.showDialogItemNote = false;
                }
                else {
                    this.showToast("error", "Warning!", result.message);
                    return false;
                }
            },

            async updateNotAutomatable(item) {

                let notAutomatable = 0;

                if (item.notAutomatable != null && item.notAutomatable != undefined) {
                    notAutomatable = item.notAutomatable == true ? 1 : 0;
                }

                this.listProductSelecteds.forEach(prs => {
                    if (prs.idProduct != item.idProduct) {
                        prs.notAutomatable = false;
                    }
                });

                if (item.id == null || item.id == undefined || item.id == 0) {
                    await this.saveItems(true);
                }

                const itemCopy = this.listProductSelecteds.filter(prs => prs.idProduct == item.idProduct)[0];

                const serviceItemNotAutomatableRequest = {
                    id: itemCopy.id,
                    notAutomatable
                }
                
                const result = await this.$store.dispatch("serviceModule/UpdateItemNotAutomatable", serviceItemNotAutomatableRequest);

                if (result.success === true) {
                    this.showToast("success", "Success!", result.message);
                    await this.updateTreeViewProduct();
                }
                else {
                    this.showToast("error", "Warning!", result.message);
                    return false;
                }
            },

            getDescriptionToolTipProduct(item) {
                if (this.userLoggedGetters.profile.systemAdmin == 1 && item.type == 'Product') {
                    return 'Double click to edit product';
                }
                else {
                    return '';
                }
            },

            openProductForm(item) {                
                if (this.userLoggedGetters.profile.systemAdmin == 1 && item.type == 'Product') {
                    this.$router.push({ name: "productForm", params: { id: item.idTable } });
                }
            },

            showDialogHO() {
                this.dialogHOResp = {
                    show: true,
                    id: this.id,
                    methodConfirm: () => {}
                }
            },

            showDialogAdditionalInfoContract() {
                this.showDialogAdditionalInformationContract = true;
            },

            async saveAdditionalInfoContract() {

                const request = {
                    idService: this.id,
                    additionalInformationContractRequest: {
                        notes: this.serviceRequest.additionalInformationContract
                    }
                }

                const result = await this.$store.dispatch("serviceModule/UpdateAdditionalInfoContract", request);

                if (result.success) {
                    this.showToast("success", "Success!", "Additional information updated successfully!");                    
                    this.showDialogAdditionalInformationContract = false;
                }
            },

            getStyleColor(item) {
                let color = 'color: var(--color__scopeofwork_product);';

                if (item.type == 'Category' || (item.type == 'Product' && item.level == 1)) {

                    color = 'color: var(--color__scopeofwork_category); font-weight: bold;';
                }
                else if (item.type == 'SubCategory') {
                    color = 'color: var(--color__scopeofwork_subcategory);';
                }
                else {
                    color = 'color: var(--color__scopeofwork_product);';
                }

                return color;
            },

            async showDialogDocusign(typeDocument) {

                const customerSelected = this.serviceRequest.customerSelected;

                let customer = {
                    name: '',
                    email: ''
                }

                if (customerSelected != null && customerSelected != undefined) {
                    customer.name = customerSelected.fullName;
                }
                customer.email = this.serviceRequest.email;

                this.dialogDocusign = {
                    show: true,
                    idAux: Math.random(),
                    id: this.id,
                    typeDocument,
                    customer,
                    methodConfirm: () => {
                        this.getRegister();
                    }
                }
            },
            
            getTotalTree(item) {
                let totalFilled = 0;
                let totalProducts = 0;

                item.children.forEach(chd => {

                    if (chd.type == 'Product') {
                        totalProducts++;
                    }

                    if (chd.qty != "0.00" && chd.qty != "") {
                        totalFilled++;
                    }

                    chd.children.forEach(prd => {
                        
                        if (prd.type == 'Product') {
                            totalProducts++;
                        }
                        
                        if (prd.qty != "0.00" && prd.qty != "") {
                            totalFilled++;
                        }

                        prd.children.forEach(bwl => {
                            if (bwl.type == 'Product') {
                                totalProducts++;
                            }

                            if (bwl.qty != "0.00" && bwl.qty != "") {
                                totalFilled++;
                            }
                        });
                    });
                });

                return `${totalFilled} / ${totalProducts}`;
            },
            

            //CUSTOM ITEM

            async uploadFiles(id, idKey, file, typeDocument, deleted = false, idKeyReference = 0) {

                const attachmentRequest = {
                    id: id,
                    idKey: idKey,
                    file: file ? file : new Blob(),
                    fileName: file ? file.name : "",
                    fileType: file ? file.type : "",
                    fileSize: file ? file.size : 0,
                    deleted: deleted ? deleted : false,
                    typeAttachment: TYPE_ATTACHMENT.SERVICE.value,
                    typeDocument: typeDocument,
                    idKeyReference: idKeyReference
                }

                if (attachmentRequest.fileName != null && attachmentRequest.fileName != undefined) {
                    let attachmentFileRequest = new FormData();

                    attachmentFileRequest.append("attachmentRequest", JSON.stringify(attachmentRequest));
                    attachmentFileRequest.append("attachmentFile", attachmentRequest.file, attachmentRequest.fileName);

                    const result = await this.$store.dispatch("attachmentModule/CreateUpdate", { 
                        attachmentFileRequest, 
                        id: 0
                    });

                    return result;
                }
                else {
                    return {
                        success: true
                    };
                }
            },

            async savePhotos() {

                let allResult = []

                this.customItemPhotos.forEach(async itemPhoto => {

                    let result = await this.uploadFiles(itemPhoto.id, this.serviceItemCustomRequest.id, itemPhoto.file, TYPE_DOCUMENT.CUSTOM_ITEMS.value, itemPhoto.deleted, itemPhoto.idKeyReference ?? 0);

                    if (result.success == false) {
                        allResult.push({
                            typeDocument: TYPE_DOCUMENT.CUSTOM_ITEMS.description,
                            message: result.message
                        })
                    }
                })

                if (allResult.length > 0) {
                    let message = ""

                    await allResult.forEach(itemResult => {
                        message += `Error to upload photos: [${itemResult.message}] \n`;
                    })

                    this.showToast("error", "Warning!", message);

                    return false;
                }
                else {
                    return true;
                }
            },

            async confirmPhotoDelete(itemPhotoToDelete) {

                this.itemPhotoToDelete = itemPhotoToDelete;

                this.dialog = {
                    show: true,
                    headerText: 'Confirmation',
                    bodyText: `You will DELETE this file [${itemPhotoToDelete.fileName}], confirm your decision?`,
                    methodConfirm: this.deletePhoto,
                    params: 0
                };
            },

            async deletePhoto() {

                this.itemPhotoToDelete.deleted = true;
            },

            async getCustomItems() {

                const idServiceProject = await this.getIDProject();
                const listCustomItems = await this.$store.dispatch("serviceModule/ListItemsCustom", idServiceProject);
                this.listCustomItems = [];

                if (listCustomItems != null && listCustomItems != undefined && listCustomItems.length > 0) {

                    listCustomItems.forEach(itemCustom => {

                        this.listCustomItems.push({
                            id: itemCustom.id,
                            description: itemCustom.description,
                            qty: itemCustom.qty,
                            priceFormatted: itemCustom.priceFormatted,
                            price: itemCustom.price,
                            total: itemCustom.total,
                            totalFormatted: itemCustom.totalFormatted,
                            note: itemCustom.note,
                            optional: itemCustom.optional,
                            optionalDescription: itemCustom.optionalDescription,
                            warrantyDays: itemCustom.warrantyDays || 0,
                            serialNumber: itemCustom.serialNumber || '',
                            newRegister: false
                        });
                    });
                }
            },

            async calculateItemCustomTotal() {
                
                let qty = parseFloat(this.serviceItemCustomRequest.qty);
                let price = parseFloat(formaterDecimalBRServer(this.serviceItemCustomRequest.price));

                let total = (qty * price).toFixed(2);

                this.serviceItemCustomRequest.total = total;
            },

             async clearFieldsCustomItem() {

                this.serviceItemCustomRequest = {
                    id: 0,
                    description: '',
                    qty: 1,
                    priceFormatted: '$ 0.00',
                    price: '$ 0.00',
                    total: '$ 0.00',
                    totalFormatted: '$ 0.00',
                    note: '',
                    optional: 0,
                    optionalDescription: 'No',
                    warrantyDays: 0,
                    serialNumber: ''
                }
            },

            async showDialogCustomItemAndClearFields()  {

                this.clearFieldsCustomItem();
                this.showDialogCustomItem = true;
            },

            async showDialogCustomItemAndFillFields(id) {
                this.clearFieldsCustomItem();
                const itemCustom = this.listCustomItems.filter(cus => cus.id == id)[0];

                if (itemCustom != null && itemCustom != undefined) {

                    this.serviceItemCustomRequest = {
                        id: itemCustom.id,
                        description: itemCustom.description,
                        qty: itemCustom.qty,
                        priceFormatted: itemCustom.priceFormatted,
                        price: itemCustom.priceFormatted,
                        total: itemCustom.totalFormatted,
                        totalFormatted: itemCustom.totalFormatted,
                        note: itemCustom.note,
                        optional: itemCustom.optional,
                        optionalDescription: itemCustom.optionalDescription,
                        warrantyDays: itemCustom.warrantyDays || 0,
                        serialNumber: itemCustom.serialNumber || '',
                    }

                    this.showDialogCustomItem = true;
                }
            },

            async showDialogCustomItemUploadImages(id) {

                this.showLoading();

                const itemCustom = this.listCustomItems.filter(cus => cus.id == id)[0];
                this.customItemPhotos = [];

                if (itemCustom != null && itemCustom != undefined) {

                    this.serviceItemCustomRequest = {
                        id: itemCustom.id,
                        description: itemCustom.description,
                        qty: itemCustom.qty,
                        priceFormatted: itemCustom.priceFormatted,
                        price: itemCustom.priceFormatted,
                        total: itemCustom.totalFormatted,
                        totalFormatted: itemCustom.totalFormatted,
                        note: itemCustom.note,
                        optional: itemCustom.optional,
                        optionalDescription: itemCustom.optionalDescription,
                        warrantyDays: itemCustom.warrantyDays || 0,
                        serialNumber: itemCustom.serialNumber || '',
                    }

                    const listAttachments = await this.$store.dispatch("attachmentModule/GetAllByDocument", { 
                        typeAttachment: TYPE_ATTACHMENT.SERVICE.value, 
                        typeDocument: TYPE_DOCUMENT.CUSTOM_ITEMS.value, 
                        idKey: itemCustom.id
                    });

                    listAttachments.forEach(itemPhoto => {

                        this.customItemPhotos.push({
                            id: itemPhoto.id,
                            file: new File([], itemPhoto.fileName),
                            type: itemPhoto.fileType,
                            fileName: itemPhoto.fileNameShort,
                            fileNameComplete: itemPhoto.fileName,
                            deleted: false,
                            src: `data:image/jpg;base64,${itemPhoto.file}`
                        })

                    })

                    this.showDialogCustomItemImages = true;
                }

                this.hideLoading();
            },

            async saveItemCustomImages() {
                
                this.showLoading();

                if (await this.savePhotos()) {
                    this.showDialogCustomItemImages = false;
                }
                else {
                    this.showToast("error", "Warning!", "Error to upload photos!");
                }

                this.hideLoading();
            },

            async saveItemCustom() {

                await this.$refs.formCustomItem.validate();
                
                const idServiceProject = await this.getIDProject();

                if (this.validFormCustomItem === false) {
                    this.showToast("error", "Warning!", "There are inconsistencies in the custom item form. Please review!");
                    return false;
                }
                else if (this.serviceItemCustomRequest.qty == 0 || formaterDecimalBR(this.serviceItemCustomRequest.price) == 0) {
                    this.showToast("error", "Warning!", "Qty and Price must be greater than zero!");
                    return false;
                }
                else {
                    var existsCustomItem = this.listCustomItems.filter(cus => cus.description === this.serviceItemCustomRequest.description);

                    if (existsCustomItem.length > 0 && this.serviceItemCustomRequest.id == 0) {
                        this.showToast("error", "Warning!", "Custom Item already registered!");
                    }
                    else {
                        this.showLoading();

                        const optional = this.serviceItemCustomRequest.optional == null || this.serviceItemCustomRequest.optional == undefined ? 0 : this.serviceItemCustomRequest.optional == true ? 1 : 0;
                        
                        if (this.serviceItemCustomRequest.id == 0) {
                            
                            this.listCustomItems.push({
                                id: Math.random(),
                                description: this.serviceItemCustomRequest.description,
                                qty: this.serviceItemCustomRequest.qty,
                                price: formaterDecimalBR(this.serviceItemCustomRequest.price),
                                total: formaterDecimalBR(this.serviceItemCustomRequest.total),
                                note: this.serviceItemCustomRequest.note,
                                optional,
                                optionalDescription: optional == 1 ? 'Yes' : 'No',
                                newRegister: true,
                                warrantyDays: this.serviceItemCustomRequest.warrantyDays || 0,
                                serialNumber: this.serviceItemCustomRequest.serialNumber || '',
                            })
                        }
                        else {

                            let itemCustom = this.listCustomItems.filter(cus => cus.id === this.serviceItemCustomRequest.id)[0]

                            if (itemCustom != null && itemCustom != undefined) {

                                itemCustom.description = this.serviceItemCustomRequest.description;
                                itemCustom.qty = this.serviceItemCustomRequest.qty;
                                itemCustom.price = formaterDecimalBR(this.serviceItemCustomRequest.price);
                                itemCustom.total = formaterDecimalBR(this.serviceItemCustomRequest.total);
                                itemCustom.note = this.serviceItemCustomRequest.note;
                                itemCustom.optional = optional;
                                itemCustom.warrantyDays = this.serviceItemCustomRequest.warrantyDays || 0;
                                itemCustom.serialNumber = this.serviceItemCustomRequest.serialNumber || '';
                            }
                        }

                        let listNewCustomItem = [];
                        this.listCustomItems.forEach (itemCustom => {
                            let id = itemCustom.id;

                            if (itemCustom.newRegister === true) {
                                id = 0;
                            }

                            listNewCustomItem.push({
                                id,
                                idServiceProject: idServiceProject,
                                description: itemCustom.description,
                                qty: itemCustom.qty.toString(),
                                price: formaterDecimalBR(itemCustom.price),
                                total: formaterDecimalBR(itemCustom.total),
                                note: itemCustom.note,
                                optional: itemCustom.optional,
                                warrantyDays: itemCustom.warrantyDays || 0,
                                serialNumber: itemCustom.serialNumber || '',
                            })
                        })

                        if (listNewCustomItem.length > 0) {
                            const result = await this.$store.dispatch("serviceModule/CreateUpdateItemsCustom", listNewCustomItem);
                            if (result.success !== true) {
                                this.showToast("error", "Warning!", result.message);
                            }
                            else {
                                this.getCustomItems();
                                // this.refreshJob = !this.refreshJob;
                            }
                        }

                        this.hideLoading();
                        this.showDialogCustomItem = false;
                    }
                }
            },

            async updateOptionalCustomItem(item) {

                let optional = 0;

                if (item.optional != null && item.optional != undefined) {
                    optional = item.optional == true ? 1 : 0;
                }

                const idItem = item.idItem || item.id;
                const serviceItemOptionalRequest = {
                    id: idItem,
                    idItem,
                    type: "CI",
                    optional
                }
                
                const result = await this.$store.dispatch("serviceModule/UpdateItemOptionalCustomItem", serviceItemOptionalRequest);

                if (result.success === true) {
                    this.showToast("success", "Success!", result.message);
                    await this.getCustomItems();                    
                    this.refreshJob = !this.refreshJob;
                    this.showDialogItemNote = false;
                }
                else {
                    this.showToast("error", "Warning!", result.message);
                    return false;
                }
            },

            async deleteItemCustom(id) {
                this.showLoading();

                await this.$store.dispatch("serviceModule/RemoveCustomItem", id);
                await this.getCustomItems();

                let index = 0
                this.listCustomItems.forEach(itemCustom => {
                    if (itemCustom.id == id) {

                        this.listCustomItems.splice(index, 1);
                    }
                    index++;
                });

                this.hideLoading();
            },
        },

        async created() {

            this.showLoading();

            await this.getLists();
            await this.getRegister();

            this.hideLoading();
        }
    })
</script>

<style scoped>
    .v-btn {
        height: 45px !important;
        width: 150px;
    }

    .imageFileName {
        font-size: 10px; 
        margin-left: 5px;
    }

    .v-stepper__content {
        padding: 0px !important;
    }

    .adjustmentInput > .v-input--selection-controls {
        padding-top: 0px !important;
        margin-top: 0px !important;
    }
</style>

<style>

    input[name="qtyField"] {
        text-align: center !important;
    }

    input[name="discount"], input[name="grandTotal"] {
        text-align: right !important;
    }

    .v-text-field__suffix {
        font-size: 12px !important;
        font-weight: bold;
    }

    .v-data-table__wrapper {
        overflow-y: hidden !important;
    }
</style>